import { StringsType } from "./StringsKeys";

const en: StringsType = {
  open: "Open",
  import: "Import",
  french: "French",
  english: "English",
  hello: "Hello",
  dashboard: "Dashboard",
  createAccount: "Create Account",
  createClient: "Create Client",
  clientName: "Client Name",
  clientEmail: "Client Email",
  clientPhone: "Client Phone",
  customerSince: "Customer Since",
  clientStatus: "Client Status",
  riskLevel: "Risk Level",
  risk: "Risk",
  profileRating: "Profile Rating",
  consolidatedBalance: "Consolidated Balance",
  folderStatus: "Folder Status",
  completionPercentage: "Completion %",
  lastUpdated: "Last Updated",
  viewDetails: "View Details",
  details: "Details",
  compare: "Compare",
  edit: "Edit",
  delete: "Delete",
  assignAdvisor: "Assign Advisor",
  updateRiskLevel: "Update Risk Level",
  searchClients: "Search clients...",
  filterByAgency: "Filter by Agency",
  filterByStatus: "Filter by Status",
  filterByRiskLevel: "Filter by Risk Level",
  filterByAdvisor: "Filter by Advisor",
  allAgencies: "All Agencies",
  allStatuses: "All Statuses",
  allRiskLevels: "All Risk Levels",
  allAdvisors: "All Advisors",
  active: "Active",
  inactive: "Inactive",
  dormant: "Dormant",
  moderate: "Moderate",
  high: "High",
  veryHigh: "Very High",
  low: "Low",
  assigned: "Assigned",
  unassigned: "Unassigned",
  totalClients: "Total Clients",
  activeClients: "Active Clients",
  highRiskClients: "High Risk Clients",
  unassignedClients: "Unassigned Clients",
  totalPortfolioValue: "Total Portfolio Value",
  averageProfileRating: "Average Profile Rating",
  loadingClients: "Loading clients...",
  noClientsFound: "No clients found",
  clientDetails: "Client Details",
  accountInformation: "Account Information",
  clientInformation: "Client Information",
  applicantContactDetails: "Applicant Contact Details",
  incomeInformation: "Income Information",
  accountType: "Account Type",
  fullName: "Full Name",
  businessKey: "Business Key",
  dateOfBirth: "Date of Birth",
  phone: "Phone",
  incomeSource: "Income Source",
  requiredDocuments: "Required Documents",
  documentsPending: "Documents Pending",
  uploadAllDocuments: "Upload All Documents",
  documentRequired: "Document Required",
  documentOptional: "Document Optional",
  upload: "Upload",
  documentsProcessed: "Documents Processed",
  progress: "Progress",
  loadingDocuments: "Loading documents...",
  documentLoadingError: "Error loading required documents",
  retryLoadingDocuments: "Retry",
  addNewClient: "Add New Client",
  exportData: "Export Data",
  refreshData: "Refresh Data",
  percent: "%",
  documents: "Documents",

  // Form Steps
  personalInformation: "Personal Information",
  contactAddressDetails: "Contact & Address Details",
  professionalFamilyInformation: "Professional & Family Information",
  professionalInformation: "Professional Information",
  familyInformation: "Family Information",

  summary: "Summary",

  // Personal Information Fields
  name: "Name",
  lastName: "Last Name",
  firstName: "First Name(s)",
  motherFullName: "Mother's Full Name",
  nationality: "Nationality",
  spokenLanguage: "Spoken Language",
  gender: "Gender",
  male: "Male",
  female: "Female",
  documentType: "Document Type",

  // Contact Details Fields
  mobilePhone: "Mobile Phone",
  homePhone: "Home Phone",
  countryOfResidence: "Country of Residence",
  cityMunicipality: "City/Municipality",
  address: "Address",
  postalAddressBP: "Postal address (P.O. Box)",
  geographicalLandmark: "Geographical Landmark",
  postalBox: "Postal Box",
  postalCode: "Postal Code",

  // Professional Information Fields
  isOwner: "Are you an owner?",
  monthlyIncome: "Monthly Income",
  hasOtherIncome: "Other Income?",
  otherIncomeAmount: "Other Income Amount",
  professionalCategory: "Professional Category",
  profession: "Profession",
  employer: "Employer",
  officePhone: "Office Phone",
  educationLevel: "Level of Education",
  maritalStatus: "Marital Status",
  numberOfChildren: "Number of Children",
  partnerFirstName: "Partner First Name",
  partnerLastName: "Partner Last Name",
  fatherLastName: "Father Last Name",
  fatherFirstName: "Father First Name",
  motherMaidenName: "Mother Last Name",
  motherFirstName: "Mother First Name",
  countryOfBirth: "Country of Birth",
  dependents: "Dependents",

  // Form Validation Messages
  fieldRequired: "This field is required",
  fieldLimited: "This field is limited to 50 characters",
  validName: "This field must at least contain 3 characters",
  phoneNumberInvalid: "Invalid phone number",
  phoneNumberTenDigits: "The number must have exactly 10 digits",
  invalidEmailFormat: "Invalid email format",
  mustBeGreaterThanZero: "Must be greater than 0",
  otherIncomeRequired:
    "Other income amount is required when other income is selected",

  // Form Status Messages
  formCompleteReady: "Form Complete & Ready to Submit",
  formIncompleteReview: "Form Incomplete - Please Review",
  formCompleteMessage:
    "All required fields have been completed. You can now submit the form.",
  formIncompleteMessage:
    "Some required fields are missing or incomplete. Please go back and complete all required fields before submitting.",

  // Navigation
  previous: "Previous",
  paginationPageSize: "per page",
  paginationPageInfo: "Page {current} / {total}",
  next: "Next",
  submit: "Submit",
  submitting: "Submitting...",
  back: "Back",

  // Form Steps Description
  personalInfoDescription: "Name, First name(s), gender, nationality...",
  contactInfoDescription: "Address, Phone, Email",
  professionalInfoDescription: "Income, assets, marital status",
  summaryDescription: "Review all information before submission",

  // Currency
  currency: "F CFA",

  // Placeholders
  placeholderLastName: "Ex: KOUASSI",
  placeholderFirstName: "Ex: Bernard",
  placeholderMotherName: "Ex: Bernardette KOUASSI",
  placeholderEmail: "Ex: mail@gmail.com",
  placeholderAddress: "Ex: Côte d'Ivoire, Abidjan, Cocody, Cité Verdoyante",
  placeholderLandmark: "Ex: Riviera 2, Anono, Near to, In front of...",
  placeholderProfession: "Ex: Tester",
  placeholderEmployer: "Ex: BOX AFRICA",

  // Cities
  abidjan: "Abidjan",
  yamoussoukro: "Yamoussoukro",
  bouake: "Bouaké",
  sanPedro: "San-Pédro",
  korhogo: "Korhogo",
  man: "Man",
  gagnoa: "Gagnoa",
  daloa: "Daloa",

  // Other
  other: "Other",
  notProvided: "Not provided",
  yes: "Yes",
  no: "No",
  administration: "Administration",
  rolesAndPermissions: "Roles & Permissions",
  users: "Users",
  attestations: "Attestations",
  offboarding: "Offboarding",
  jitAccess: "JIT Access",
  settings: "Settings",
  sodRules: "SoD Rules",
  adMapping: "AD Mappings",
  runtimeDecisions: "Runtime Decisions",
  enterprise: "Enterprise",
  expired: "Expired",
  newRole: "New Role",
  role: "Role",
  newRequest: "New Request",
  publishRole: "Publish Role",
  publishRoleAttestation:
    "I attest that this role complies with security and compliance policies",
  publishingRole: "Publishing role...",
  rolePublishedSuccess: "Role published successfully.",
  rolePublishedError: "Failed to publish role.",
  confirmPublishRoleTitle: "Confirm role publication",
  confirmPublishRoleDescription:
    "This action will publish this role permanently and make it available in production.",
  simulateUser: "Simulate User",
  mapAD: "Map AD",
  save: "Save",
  search: "Search",
  selectValue: "Select value...",
  searchValue: "Search value...",
  noValueFound: "No value found.",
  prospectsSearch: "Name, email, phone, ...",
  prospectsSearchSection: "Find a prospect",
  prospectsSearchFilters: "Refine pipeline",
  prospectsShowFilters: "Show search",
  prospectsHideFilters: "Hide search",
  statusProspect: "Prospect",
  statusPendingScreening: "Under compliance review (L1/EDD)",
  statusRefused: "Refused",
  statusFilterHelp: "What each status means",
  statusProspectHint:
    "Case still being put together, not yet registered as a customer. Shown together with the two other statuses when no filter is selected.",
  statusPendingScreeningHint:
    "Customer already screened and registered in the referential but without a bank account, awaiting a compliance review decision (L1 or four-eyes EDD). The account is created once the review is approved.",
  statusRefusedHint:
    "Unfavourable review: the customer stays registered and no account is created. Compliance can reopen the case, which sends it back to pending screening.",
  typeFilterHelp: "What each segment covers",
  physicalPersonHint:
    "Individual. This is the segment of the vast majority of cases, shown as \"PP\" in the list.",
  legalPersonHint:
    "Company or organisation, shown as \"PM\". Its case also carries a legal identity (legal form, RCCM) and its related persons.",
  channelFilterHelp: "How the relationship was opened",
  channelDigitalHint:
    "Opened remotely through the self-onboarding journey, without a branch visit or biometric verification. Scoring takes this into account.",
  channelAgencyHint:
    "Created in a branch by an advisor, with biometric verification of the customer.",
  channelCbsImportHint:
    "Customer already known to the core banking system, brought into the referential by synchronisation rather than created here.",
  periodCreated: "Creation period",
  periodFilterHelp: "How the period is applied",
  periodFilterHint:
    "Filters on the case creation date. Both bounds are inclusive: from the 1st to the 1st does return the cases created that day. The list is only filtered once both dates are set.",
  channelDigital: "Digital",
  channelAgency: "Branch",
  channelCbsImport: "Imported from core banking",
  prospectsSearchFiltersHint:
    "Filter prospects by type, status, and creation channel.",
  reset: "Reset",
  results: "Results",
  status: "Status",
  criticality: "Criticality",
  frequency: "Frequency",
  sod: "SoD",
  help: "Help",
  views: "Views",
  generalInformation: "General Information",
  prefilledFromCreationStep:
    "Already provided when the prospect was created. Click Edit to correct it.",
  matrixViewDescription: "Matrix view of roles and permissions",
  usersDescription: "Manage the users of the platform",
  usersSearchHint: "Name, login or email",
  roleAndOwner: "Role & Owner",
  archived: "Archived",
  draft: "Draft",
  published: "Published",
  none: "None",
  twoSod: "2 SoD →",
  consult: "Consult",
  modify: "Modify",
  approve: "Approve",
  export: "Export",
  compliance: "Compliance",
  credit: "Credit",
  gdpr: "GDPR",
  linesPerPage: "Lines per page",
  pageInfo: "Page {page} of {total}",
  notifications: "Notifications",
  noNotifications: "No notifications",
  noNotificationsHint:
    "Alerts about your cases, compliance, and administration will appear here.",
  notificationsUnread: "{{count}} unread",
  notificationsTabAll: "All",
  notificationsTabUnread: "Unread",
  notificationsEmptyUnread: "No unread notifications",
  notificationsToday: "Today",
  notificationsYesterday: "Yesterday",
  notificationsEarlier: "Earlier",
  markAllAsRead: "Mark all read",

  // Form Steps Title
  formSteps: "Form Steps",
  fillInInformation: "Fill in the information",

  // Error Messages
  pleaseFixErrors: "Please fix the following errors:",
  failedToSubmit: "Failed to submit form. Please try again.",
  formSubmittedSuccessfully: "Form submitted successfully!",
  contactInfoUpdated: "Contact information has been updated successfully.",

  // Step Status
  current: "current",
  completed: "completed",
  pending: "pending",
  error: "error",

  failedGettingUserRole: "Failed getting user role",
  backToHome: "Back to home",
  pageNotFound: "Page not found",
  WeCouldNotFindThePageYouAreLookingFor:
    "We couldn't find the page you are looking for.",
  internalServerError: "Internal server error",
  oopsSomethingWentWrong: "Oops, something went wrong",
  youAreNotAuthorized: "You are not authorized to access this page",
  youDonTHavePermissionToAccessThisPage:
    "You don't have permission to access this page",
  permissionDeniedPageDescription:
    "Your account does not include the required permissions. Contact your administrator if you need access.",
  welcomeTo: "Welcome to",
  pleaseSignIn: "Please sign-in to your account and start the adventure",
  password: "Password",
  rememberMe: "Remember me",
  loginHeroTitle: "Collaborator space",
  loginHeroSubtitle:
    "Access your compliance, KYC, and client file tools securely.",
  loginSecurityNote: "Secure and audited platform",
  loginFormSecurityNote: "Secure and encrypted connection",
  loginHelperText: "Enter your professional credentials to continue.",
  loginEmailPlaceholder: "e.g. agnese@bni.ci",
  credentials: "Credentials",
  badCredentials: "Authentication failed.",
  emailOrPasswordInvalid: "Email or Password is invalid",
  forgotPassword: "Forgot password",
  login: "Login",
  firstLoginResetTitle: "First sign-in",
  firstLoginResetSubtitle:
    "For security, you must set a new password before continuing.",
  currentPassword: "Current password",
  newPasswordChoice: "New password",
  confirmNewPassword: "Confirm new password",
  passwordsDoNotMatch: "Passwords do not match",
  passwordResetSuccess: "Password reset successfully.",
  passwordResetSuccessReconnectHint:
    "You can now sign in with your new password.",
  changePassword: "Save new password",
  passwordStrengthWeak: "Weak",
  passwordStrengthFair: "Fair",
  passwordStrengthGood: "Good",
  passwordStrengthStrong: "Strong",
  passwordStrengthHint: "Password strength",
  passwordRequirementMinLength: "At least 8 characters",
  passwordRequirementUppercase: "At least one uppercase letter",
  passwordRequirementLowercase: "At least one lowercase letter",
  passwordRequirementDigit: "At least one number",
  passwordRequirementSpecial: "At least one special character",
  passwordConfirmMatches: "Passwords match",
  passwordMustDifferFromCurrent:
    "New password must be different from your current password",
  inputLogin: "Identifier",
  newOnOurPlatform: "New on our platform",
  createAnAccount: "Create an account",
  or: "or",
  errorOccurred: "An error occurred",
  unexpectedOrNetworkError: "Unexpected or network error",
  unauthorizedAction: "Unauthorized action",
  subscriptionRequired: "Subscription required",
  resourceNotFound: "Resource not found",
  invalidInfos: "Invalid infos",
  conflictEncountered: "Conflict encountered",
  unavailableServer: "Unavailable server",
  logoutFailed: "Logout failed",
  logout: "Logout",
  sessionExpired: "Session expired",
  sessionExpiredMessage:
    "Your session has expired. Please log in again to continue.",
  externalResourceUnavailable:
    "External resource unavailable, please try again or try again later.",
  unexpectedError: "Unexpected error, please try again or try again later.",
  requiredField: "This field is required",
  invalidEmail: "Invalid email",
  invalidPassword: "Invalid password",
  email: "Email",
  failed: "Failed",
  userAvatar: "User avatar",
  operationFailed: "Operation failed",
  clientDataNotAvailable: "Client data not available.",
  FailedToLogoutUser: "Failed to logout user",
  tryAgain: "Try again",
  activities: "Activities",
  customers: "Customers",
  prospects: "Prospects",
  pipeline: "Pipeline",
  possibleMatch: "Possible match",
  duplicates: "Duplicates",
  individuals: "Individuals",
  professionals: "Professionals",
  products: "Products",
  inquirie_create_client: "Create client",
  inquiries: "Inquiries",
  inquirie: "Inquirie",
  folders: "Folders",
  marketing: "Marketing",
  atm: "Agencies & ATMs",
  period: "Period",
  day: "Day",
  week: "Week",
  month: "Month",
  trimester: "Trimester",
  semester: "Semester",
  year: "Year",
  compareToPreviousDay: "compared to the previous day",
  compareToPreviousWeek: "compared to last week",
  compareToPreviousMonth: "compared to last month",
  compareToPreviousTrimester: "compared to last quarter",
  compareToPreviousSemester: "compared to last semester",
  compareToPreviousYear: "compared to last year",
  client: "Client",
  client360: "Clients 360",
  client360SearchFilters: "Refine client search",
  client360SearchFiltersHint:
    "Combine criteria to narrow down the client list.",
  client360SearchSection: "Find a client",
  client360ShowFilters: "Show search",
  client360HideFilters: "Hide search",
  agency: "Agency",
  advisorName: "Advisor",
  since: "Since",
  profile: "Profile",
  totalBalance: "Total Balance",
  actions: "Actions",
  columns: "Columns",
  noResults: "No results.",
  selectedRows: "selected row(s)",
  advancedFilters: "Advanced Filters",
  kpi: "KPI",
  clear: "Clear",
  call: "Call",
  activity: "Activity",
  accountsProducts: "Account & Products",
  transactions: "Transactions",
  analyse: "Analyse risk",
  informations: "Informations",
  notesInteractions: "Notes & Interactions",
  networkError: "Network error",
  customersPerPage: "Customers per page",
  loading: "Loading",
  signature: "Signature",
  clientSince: "Customer since",
  placeOfBirth: "Place of birth",
  documentNumber: "Document number",
  dateOfIssue: "Date of issue",
  countryOfIssue: "Country of issue",
  placeOfDelivery: "Place of issue",
  documentReference: "Doc. reference",
  identityDocumentType: "Type of identity document",
  identityDocumentNumber: "Identity document number",
  nationalIdNumber: "National Identity Number (NIN)",
  expiryDate: "Expiry dade",
  validatedPart: "Validated part",
  completionLevel: "Completion level",

  // RBAC Matrix - Additional keys
  matrixRBAC: "RBAC Matrix",
  rbacMatrixSearchSection: "Search roles",
  rbacMatrixSearchHint: "Role name or label",
  rbacMatrixFilters: "Refine matrix",
  rbacMatrixFiltersHint:
    "Filter by status, criticality, review cadence, and SoD compliance.",
  rolesAndAttributions: "Roles & Attributions",
  medium: "Medium",
  dependencies: "Dependencies",
  nbPermissions: "Nb permissions",
  rulesManagement: "Rules",
  newRule: "New Rule",
  ruleName: "Rule name",
  ruleDescription: "Description",
  noRulesFound: "No rules found",
  invalidPhoneFormat: "Invalid phone format",

  // User
  user: "User",
  state: "State",
  presence: "Presence",
  backup: "Backup",
  permissions: "Permissions",

  // Documents
  category: "Category",
  date: "Date",
  send: "Send",
  download: "Download",
  documentDownloaded: "Document downloaded",
  documentDownloadError: "An error occurred while downloading the document",
  documentPreviewTitle: "Document preview",
  documentPreviewError: "Unable to load document preview",
  documentPreviewNotSupported: "Preview not available for this file type",
  screeningReportDownloaded: "Screening report downloaded",
  screeningReportDownloadError:
    "An error occurred while downloading the screening report",
  documentPerPage: "Documents per page",
  demandes: "Requests",
  nouvelleDemande: "New Request",
  // Demandes - Selection manuelle UI
  filters: "Filters",
  channel: "Channel",
  country: "Country",
  segment: "Segment",
  availableRequests: "Available requests",
  continue: "Continue",
  requiredFields: "Required fields",
  missingFields: "Missing fields",
  // Request items
  request_create_account: "Open a bank account",
  request_create_account_desc: "Start a bank account opening.",
  request_onboarding_a2: "Start Onboarding (A2)",
  request_onboarding_a2_desc:
    "Open an A2 onboarding case for a client/prospect.",
  request_regen_otp: "Regenerate access (OTP)",
  request_regen_otp_desc:
    "Send OTP instructions to reset password / reconnect.",
  request_secure_upload_reminder: "Secure upload reminder",
  request_secure_upload_reminder_desc:
    "Send a reminder with a secure link for document upload.",
  request_id_replacement: "Identity document replacement",
  request_id_replacement_desc:
    "Replace an expired or invalid identity document.",
  request_address_change: "Address change",
  request_address_change_desc: "Update address and supporting documents.",
  request_four_eyes: "4‑eyes document control",
  request_four_eyes_desc: "Trigger a 4‑eyes control on a document file.",
  request_rekcy: "Trigger Re‑KYC",
  request_rekcy_desc: "Open a Re‑KYC request according to the policy.",
  request_export_kpi: "Export compliance KPIs",
  request_export_kpi_desc:
    "Export KPIs (completeness, expired, OCR errors, reuse).",
  request_contact_update: "Contact details update",
  request_contact_update_desc: "Update client's contact information.",
  request_account_closure: "Account closure",
  request_account_closure_desc: "Close an active bank account.",
  request_add_proxy: "Add a power of attorney (proxy)",
  request_add_proxy_desc: "Create/add a proxy for a client (scope and limits).",
  request_pep_declaration: "PEP declaration",
  request_pep_declaration_desc:
    "Declare or update PEP status (client or relative).",
  request_civil_status_change: "Civil status change",
  request_civil_status_change_desc:
    "Declare a civil status change with supporting documents.",
  request_add_legal_representative: "Add legal representative",
  request_add_legal_representative_desc:
    "Add or designate a legal representative with documents.",
  request_income_employer_update: "Update income and employer",
  request_income_employer_update_desc:
    "Update monthly income, employer and activity sector.",
  request_family_situation_change: "Family situation change",
  request_family_situation_change_desc:
    "Update marital regime, spouse and number of children.",
  request_create_prospect: "Create a prospect",
  request_create_prospect_desc:
    "Enter a prospect and trigger the associated flow.",

  // Prospects
  type: "Type",
  contact: "Contact",
  accessStatus: "Access status",
  canal: "Canal",
  screening: "Screening",
  additionalDocuments: "Additional documents & exhibits",
  lastUpdate: "Last Update",
  createdAt: "Created at",

  birthDate: "Birth date",
  notes: "Notes",
  motif: "Reason",
  address1: "Address 1",
  address2: "Address 2",
  city: "City",
  deliveredDate: "Delivered date",
  IdDocType: "Type of document",
  IdDocNumber: "Document number",
  birthPlace: "Birth place",

  // Onboarding
  identification: "Identification",
  update: "Edit",
  editable: "Editable",
  readOnly: "Read only",

  // client
  clients: "Clients",
  selectClient: "Select a client",
  selectClientDescription: "Search for a client to open its 360° view.",
  clientSearch: "Name, Party ID, NCI, phone, email",
  sensitiveClientsFilter: "Sensitivity",
  sensitiveFilterAll: "All",
  sensitiveFilterWithout: "Non-sensitive",
  sensitiveFilterWith: "Sensitive",
  kyc: "KYC",
  partyid: "Party ID",
  account: "Accounts",

  synthese: "Synthesis",
  risqueReKyc: "Risk & Re-KYC",
  scoringProfilTitle: "Risk Profile",
  scoringScore: "Score",
  scoringDeclencheurs: "Triggers",
  scoringVoirDetails: "View details",
  scoringPolitiqueRisque: "Risk Policy",
  scoringNotCalculated: "Risk profile not yet calculated",
  scoringClasseDeRisque: "Risk class",
  scoringNonCalcule: "Not calculated",
  scoringTrackA: "Identity Reference",
  scoringTrackB: "External check",
  scoringCombined: "Combined score",
  scoringDecision: "Decision",
  scoringCompleteness: "Completeness",
  scoringScoredAt: "Scored at",
  scoringScoredBy: "Scored by",
  scoringTrigger: "Trigger",
  scoringFactorsTitle: "Factors",
  scoringLoadError: "Failed to load the risk profile.",
  scoringClassification: "Classification",
  scoringRawScore: "Raw score",
  scoringWeight: "Weight",
  scoringHardOverrides: "Overrides",
  scoringEntity: "Entity",
  scoringEntityLabel: "Label",
  scoringLevel: "Level",
  scoringPoints: "Points",
  accounts: "Accounts",
  accountSingular: "Account",
  consents: "Consents",
  timeline: "Timeline",
  fiche: "Client File",

  // Create Prospect Page
  createProspectPhysicalPersonTitle:
    "Create a prospect — Individual (PP) (BCEAO)",
  requiredInformation: "Required information",
  optionalInformation: "Optional information",
  physicalPerson: "Individual",
  sex: "Gender",
  masculine: "Male",
  feminine: "Female",
  selectOption: "Select",
  cni: "National ID",
  passport: "PASSPORT",
  drivingLicense: "DRIVING LICENSE",
  notesOptional: "Notes (optional)",
  dateFormat: "dd/mm/yyyy",
  errorCreatingProspect: "Error creating prospect",
  prospectCreatedSuccessfully: "Prospect created successfully!",
  prospectCreatedRedirectMessage:
    "Your prospect has been created successfully. You will be redirected...",
  requiredFieldsDisclaimer:
    "* required fields — at least one contact (phone or email).",
  cancel: "Cancel",
  create: "Create",
  creating: "Creating...",
  idType: "ID Type",
  idNumber: "ID Number",
  issueDate: "Issue Date",
  addressLine1: "Address (line 1)",
  addressLine2: "Address (line 2)",

  // New prospect form translations (English)
  civilite: "Title",
  genre: "Gender",
  masculineShort: "M",
  feminineShort: "F",
  mr: "Mr.",
  mrs: "Mrs.",
  miss: "Miss",
  mobile: "Mobile phone",
  sendOTP: "Send OTP",
  OTPSent: "OTP sent",
  verifyOTP: "Verify",
  otpCode: "Verification code",
  productOfInterest: "Product of interest",
  productsOfInterest: "Products of interest",
  intentComment: "Reason / Comment",
  intentCommentPlaceholder:
    "Specify the reason or add a comment… (280 characters max.)",
  createProspectAccountObject: "Account object",
  wantsContactForProducts: "Wants to be contacted for savings/card/credit",
  validateAndContinue: "Validate & continue",
  startOnboarding: "Start onboarding",
  coordinatesAndIntent: "Contact details & Intent",
  notesAndMentions: "Notes & @mentions",
  requestContext: "Request context",
  what: "Request type",
  produit: "Product",
  notDefined: "Not defined",
  characterLimit: "280 characters",
  chooseOption: "Choose",
  carte: "Card",
  epargne: "Savings",
  compteAVueXOF: "Current account (XOF)",
  suivant: "Next",

  rm: "RM",
  relationshipManager: "Relationship manager",
  prospectCreated: "Prospect created",
  prospectCreatedModalDescription:
    "Do you want to collect documents and consents?",
  prospectCreatedModalDescriptionPm:
    "Find it in the prospect list to continue processing it.",
  clientCreated: "Client created successfully",
  clientCreatedModalDescription:
    "Do you want to continue on the client profile?",
  nextStep: "Next steps",
  verifyRequiredDocuments: "Verify required documents.",
  confirmConsents: "Confirm KYC and marketing consents.",
  goToProspectList: "Back to the list of prospects",
  continueOnboarding: "Continue account opening",
  accessToClientProfile: "Access to client profile",
  continueClientProfile: "Continue client profile",
  generateClientAccess: "Generate client access",
  pepOnboardingSubmittedTitle: "Submission successful",
  pepOnboardingSubmittedDescription:
    "The file has been recorded and sent for processing.",
  pepOnboardingComplianceFourEyesMessage:
    "It has been sent for four-eyes review to the Compliance department.",
  pepOnboardingAccountCreationPendingMessage:
    "The client account can only be created after Compliance validation.",
  createNewProspect: "Create a new prospect",
  onboardingGate_loading: "Checking screening status…",
  onboardingGate_error:
    "Could not retrieve the screening verdict. Please try again.",
  onboardingGate_unavailable:
    "Screening verdict unavailable. Please try again.",
  onboardingGate_pass_banner:
    "Screening cleared — customer creation is allowed.",
  onboardingGate_outcome_created: "The customer was created successfully.",
  onboardingGate_sanctions:
    "Creation refused: sanctions match. The Compliance department is notified.",
  onboardingGate_pep:
    "PEP customer: the file is forwarded to Compliance for four-eyes review. Compliance takes over.",
  onboardingGate_screeningInProgress:
    "Screening in progress… The verdict will be available shortly.",
  onboardingGate_softPass:
    "The file will be forwarded to Compliance for review.",
  onboardingGate_outcome_createdRouted:
    "The customer was created. The file will be forwarded to Compliance for review.",
  onboardingGate_routedReview:
    "The file will be forwarded to Compliance for review.",
  onboardingGate_refresh: "Refresh",
  onboardingGate_routed_title: "File forwarded to Compliance",
  onboardingGate_sanctions_title: "Creation refused",

  onlyLetters: "This field must contain only letters, spaces or dashes",
  identityInformation: "Identity information",
  companyIdentityInformation: "Company identity",
  stepIncompleteHint: "Complete this step to continue.",
  declarantContact: "Reporting contact",
  companyName: "Company name",
  registrationNumberOptional: "Registration number (RCCM)",
  contactPersonName: "Contact name",
  declarantRole: "Declarant's role",
  pmOnboardingUnavailableTitle: "Feature not available yet",
  pmOnboardingUnavailableDescription:
    "Online onboarding for legal entities is still under construction. This feature will be available soon for this prospect category.",
  understood: "Understood",

  onboarding: "Onboarding",
  productIntent: "Product intent / interest",
  backgroundToRequest: "Background to the request",
  infosIntent: "Contact Information & Intent",
  addressProfile: "Contact details (address & profile)",
  salaryAmount: "Salary (amount)",
  activitySector: "Activity sector",
  stepEntreprise: "Company",
  legalIdentificationKyb: "Legal identification (KYB)",
  addressAndContact: "Address & contact",
  tradeName: "Trade name",
  companyPhone: "Company phone",
  companyEmail: "Company email",
  legalForm: "Legal form",
  registrationNumber: "Registration number (RCCM)",
  taxId: "Tax ID (NIF)",
  incorporationCountry: "Country of incorporation",
  incorporationDate: "Incorporation date",
  shareCapital: "Share capital (FCFA)",
  headOfficeAddress: "Head office address",
  financialAndAdministrative: "Financial and administrative data",
  authorizationNumber: "Operating authorization number",
  fiscalYearStart: "Fiscal year start",
  fiscalYearEnd: "Fiscal year end",
  annualRevenue: "Annual revenue excl. tax (XOF)",
  consolidatedRevenue: "Consolidated revenue excl. tax (XOF)",
  netResult: "Net result (XOF)",
  totalAssets: "Total assets (XOF)",
  amountInvalid: "Enter a whole amount in CFA francs.",
  fiscalYearInvalid: "The fiscal year must end after it starts.",
  financialHint: "Sent to the CBS when the account is opened, at approval.",
  corporateObject: "Corporate object",
  legalFormSarl: "SARL",
  legalFormSa: "SA",
  legalFormSas: "SAS",
  legalFormGie: "GIE",
  legalFormHolding: "Holding",
  legalFormAssociation: "Association / NGO",
  legalFormPublicEntity: "Public entity",
  sectorCommerce: "General trade",
  sectorAgriculture: "Agriculture",
  sectorConstruction: "Construction",
  sectorRealEstate: "Real estate",
  sectorForeignExchange: "Currency exchange",
  sectorGambling: "Gambling",
  sectorFinancialServices: "Financial services",
  sectorTransport: "Transport / Logistics",
  saveSuccessful: "Saved successfully",
  saveFailed: "Save failed",
  stepRepresentants: "Representatives",
  addRepresentative: "Add a representative / proxy holder",
  removeRepresentative: "Remove",
  activeSignatoryBlocksRemoval:
    "This person already holds an active mandate. Revoke the mandate before removing them.",
  alreadyKnownInSystem: "Already known in the system",
  representativesListTitle: "Representatives and proxies",
  showDetails: "Details",
  hideDetails: "Hide",
  addedOn: "Added on",
  identitySource: "Source",
  sourceAgentInput: "Entered manually",
  sourceRicProjection: "Projected from the RIC",
  rolesHeld: "Roles",
  addRole: "Add a role",
  removeRole: "Remove",
  lastRoleCannotBeRemoved: "Last role: cannot be removed",
  noRoleToAdd: "Every available role is already assigned",
  searchExistingPerson: "Search an existing person",
  searchPersonPlaceholder: "Representative's name...",
  noResultsFound: "No results",
  manualEntry: "Manual entry",
  chooseRole: "Choose a role",
  possibleMatchesFound:
    "A matching profile already exists — reuse it or confirm this is a different person.",
  matchTypeExact: "Exact match",
  matchTypePartial: "Partial match — verify before merging",
  reuseThisPerson: "Reuse this person",
  confirmDifferentPerson: "This is a different person",
  representativeAddedSuccess: "Representative added to the case",
  removalNotSupportedYet:
    "Removing a representative isn't supported yet: assign them another role instead if needed.",
  alreadyLinkedRoles: "Roles already held",
  functionGerant: "Manager",
  functionDG: "General Manager",
  functionPDG: "Chairman & CEO",
  functionPresident: "Chairman",
  functionAdministrateur: "Director",
  residenceCountry: "Country of residence",
  identityDocumentSectionTitle: "Identity document",
  runOcr: "Run OCR",
  uploadDocumentToContinue:
    "Upload the identity document and run OCR to continue.",
  representativeDocumentType: "Document type",
  documentTypeCNI: "National ID",
  documentTypePassport: "Passport",
  documentTypeResidencePermit: "Residence permit",
  mandateSectionTitle: "Mandate & powers",
  mandateReference: "Mandate reference",
  mandateType: "Mandate type",
  mandateStartDate: "Start date",
  mandateEndDate: "End date",
  mandateCertifiedDocument: "Certified document",
  mandateTypeStatutory: "Statutory legal representative",
  mandateTypeProxy: "Proxy",
  mandateTypeDelegation: "Delegation",
  mandateTypeBankMandate: "Bank mandate",
  mandatesSectionTitle: "Mandates",
  addMandate: "Add mandate holder",
  mandateRole: "Mandate role",
  mandateRolePrincipal: "Principal",
  mandateRoleSimple: "Simple",
  mandateReason: "Reason / justification",
  mandateSaved: "Mandate holder saved successfully",
  mandateSaveFailed: "Failed to save mandate holder",
  mandateRemoved: "Mandate holder removed successfully",
  mandateRemoveFailed: "Failed to remove mandate holder",
  mandateRemoveConfirmTitle: "Remove mandate holder",
  mandateRemoveConfirmDescription:
    "Provide a reason for removal. This reason will be preserved in mandate history.",
  mandateRemoveReasonLabel: "Removal reason",
  mandateRemoveReasonPlaceholder:
    "Describe why the mandate holder is being removed… (500 chars max.)",
  mandateRemoveReasonRequired:
    "A reason is required to remove the mandate holder.",
  mandatePrincipalAlreadyExists:
    "An active principal mandate holder already exists. Only simple mandate holders can be added.",
  mandateListEmpty: "No mandate holders registered",
  stepActionnariat: "Shareholding & UBO",
  significantShareholdersQuestion:
    "Are there any shareholders holding ≥ 25% of capital or voting rights?",
  addShareholder: "Add a shareholder",
  removeShareholder: "Remove shareholder",
  personTypePP: "Individual",
  personTypePM: "Legal entity",
  percentageHeldLabel: "% held",
  shareholderLegalName: "Legal name",
  shareholderRegistryNumber: "Registry number",
  uboEffectifLabel: "Effective UBO",
  belowUboThresholdLabel: "Below 25% threshold",
  shareholdingSumError: "Direct shareholders' percentages must sum to 100%.",
  completeRequiredFieldsMessage: "Please complete all required fields.",
  controlGraphTitle: "Control graph",
  exportGraph: "Export",
  exportComingSoon: "Coming soon",
  shareholderIdentificationDate: "Identification date",
  shareholderLastVerificationDate: "Last verification",
  shareholderProofSource: "Proof source",
  legendPpIdentified: "Identified individual",
  legendPmIntermediary: "Intermediary legal entity",
  legendBelowThreshold: "Below threshold",

  stepDocuments: "Documents",
  documentChecklistTitle: "Required documents",
  documentChecklistDescription:
    "This checklist is generated from the company's legal form and country.",
  documentChecklistLoading: "Generating the document checklist…",
  documentChecklistEmpty: "No document checklist yet.",
  documentProvided: "Provided",
  documentRequiredBadge: "Required",
  documentChecklistIncompleteMessage:
    "All required documents must be marked as provided before continuing.",
  documentIndeterminateBadge: "Indeterminate",
  documentChecklistIndeterminateMessage:
    "The document requirements could not be determined yet — check with compliance before continuing.",
  documentStatusAttendue: "Awaited",
  documentStatusRecue: "Received, pending review",
  documentStatusValide: "Validated",
  documentStatusExpiree: "Expired, needs renewal",
  documentOptionalBadge: "Optional",
  documentRegulatorySource: "Standard applied:",
  documentUploadButton: "Upload the document",
  documentReplaceButton: "Replace the document",
  documentUploadUnavailable: "Online upload not available yet",
  documentUploadInProgress: "Uploading…",
  documentUploadError: "Upload failed, try again.",
  documentValidateButton: "Validate the document",
  documentValidateError: "Validation failed, try again.",
  documentTypeStatuts: "Articles of association",
  documentTypeRccm: "RCCM extract",
  documentTypePieceIdentiteRl: "Legal representative's ID document",
  documentTypeNominationDirigeants: "Appointment of officers",
  documentTypeDeclarationBeneficiairesEffectifs:
    "Beneficial owners declaration",
  documentTypeConventionGie: "GIE founding agreement",
  documentTypeRecepisseDeclaration: "Declaration receipt",

  stepScreening: "Screening",
  pmScreeningTitle: "Sanctions / PEP / adverse media screening",
  pmScreeningDescription:
    "Screening is executed upstream (RIC / VNeuron) against the company, its shareholders and its representatives — this screen only projects the result.",
  pmScreeningRunning: "Projecting screening results…",
  pmScreeningEntityTypeEntreprise: "Company",
  pmScreeningEntityTypeActionnaire: "Shareholder",
  pmScreeningEntityTypeRepresentant: "Representative",
  pmScreeningListSourceSanctions: "Sanctions",
  pmScreeningListSourcePep: "PEP",
  pmScreeningListSourceAdverseMedia: "Adverse media",
  pmScreeningQualificationTruePositive: "True positive",
  pmScreeningQualificationFalsePositive: "False positive",
  pmScreeningQualificationUncertain: "Uncertain (escalated)",
  pmScreeningFalsePositivePendingValidation:
    "False positive — pending validation",
  pmScreeningStatusPending: "Pending",
  pmScreeningStatusClear: "Clear",
  pmScreeningStatusHit: "Hit",
  pmScreeningStatusInconclusive: "Inconclusive",

  stepRiskScore: "Risk score",
  riskScoreTitle: "Composite BCEAO risk score",
  riskScoreDescription:
    "Computed from the company's activity sector, its representatives and the screening results.",
  riskScoreLoading: "Computing the risk score…",
  riskScoreCompositeLabel: "Composite score",
  riskScoreLevelLabel: "Risk level",
  riskScoreFactorsTitle: "Risk factors",
  riskScoreVigilanceMessage: "Enhanced vigilance is required for this case.",
  riskLevelLow: "Low",
  riskLevelStandard: "Standard",
  riskLevelHigh: "High",
  riskLevelCritical: "Critical",
  riskFactorBase: "Base composite score",
  riskFactorHoldingStructure: "Holding / complex structure",
  riskFactorIntermediatePM: "Intermediate legal entity in the chain",
  riskFactorForeignUbo: "Foreign UBO",
  riskFactorSensitiveSector: "Sensitive activity sector",
  riskFactorPepRepresentative: "PEP (legal rep. or UBO)",
  riskFactorDigitalChannel: "Digital channel",
  riskFactorGafiNonCooperativeCountry: "FATF non-cooperative country",
  riskFactorYoungCompany: "Company under 2 years old",

  decisionOutcomeApprovedComplete: "Complete file / Approve",
  decisionOutcomeApprovedWithRestrictions: "Approve with restrictions",
  decisionOutcomeRejected: "Rejected",
  decisionOutcomeRegulatoryHold: "Regulatory hold",

  stepAccountOpening: "Account opening",
  stepSubmission: "Submission",
  submissionTitle: "Submit the case for review",
  submissionDescription: "The case is sent to the compliance analyst. It can no longer be edited once submitted, unless a complement is requested.",
  submissionSubmitButton: "Submit for review",
  submissionAlreadyInInstruction: "This dossier is already submitted: it is with the compliance team, there is nothing left to submit.",
  submissionOpenCase: "Open the dossier",
  submissionPrereqTitle: "Before submitting",
  submissionPrereqBeneficialOwner: "A beneficial owner is identified, or a director fallback is documented",
  submissionPrereqRegistration: "The registration of the company (RCCM) is verified by the compliance team",
  submissionPrereqOwnersVerified: "The beneficial owners are verified (otherwise the dossier is flagged to the compliance team)",
  submissionPrereqDocuments: "The mandatory documents are received",
  submissionPrereqDocumentsMissing: "mandatory document(s) missing: the dossier will wait for the customer",
  submissionPrereqFix: "Fix",
  submissionPrereqBlocked: "Fix the blocking points above to be able to submit.",
  submissionBlockedTitle: "The case cannot be submitted yet",
  submissionBlockerBeneficialOwnerMissing: "No beneficial owner has been identified, and no director fallback has been submitted or validated.",
  submissionBlockerRegistrationNotVerified: "No RCCM registration has been verified.",
  submissionBlockerUnknown: "A prerequisite is missing:",
  submissionSubmittedMessage: "Case submitted. It is now under review by compliance.",
  submissionAwaitingClientMessage: "Case submitted. Mandatory documents are still missing, so it is waiting for your complements. Missing documents:",
  submissionAlreadySubmittedMessage: "This case had already been submitted.",
  submissionFlagBeNonVerifie: "Vigilance: a beneficial owner is not verified.",
  submissionFlagStructureOpaque: "Vigilance: the ownership structure is opaque.",
  kybCaseTitle: "KYB case",
  kybCaseOpenButton: "KYB case",
  kybCaseLoadError: "The KYB case could not be loaded.",
  kybCaseNotFound: "This customer has no active KYB case yet. Submit the onboarding file first.",
  kybCaseStatusLabel: "Status",
  kybCaseStatusOpen: "Draft",
  kybCaseStatusSubmitted: "Under review",
  kybCaseStatusAwaitingClient: "Waiting for the client",
  kybCaseStatusApproved: "Approved",
  kybCaseStatusApprovedWithRestrictions: "Approved with restrictions",
  kybCaseStatusRejected: "Rejected",
  kybCaseStatusRegulatoryHold: "On regulatory hold",
  kybCaseStatusEnhancedSurveillance: "Enhanced surveillance",
  kybCaseStatusClosed: "Closed",
  kybMandatesTitle: "Case mandates",
  kybMandatesBack: "Back to the case",
  kybMandatesOpen: "Mandates",
  kybMandatesEmpty: "No mandate",
  kybMandatesLoadError: "The mandates could not be loaded.",
  kybMandatesRetry: "Retry",
  kybMandatesNoCase: "This client has no active case.",
  kybMandateColMandataire: "Agent",
  kybMandateColType: "Type",
  kybMandateColPerimeter: "Scope",
  kybMandateColCeiling: "Ceiling",
  kybMandateColPeriod: "Period",
  kybMandateColSignature: "Signature",
  kybMandateColStatus: "Status",
  kybMandateTypeStandard: "Standard",
  kybMandateTypeDelegation: "Temporary delegation",
  kybMandateSignatureAlone: "Alone",
  kybMandateSignatureJoint: "Joint",
  kybMandateStatusPending: "Awaiting validation",
  kybMandateStatusActive: "Active",
  kybMandateStatusExpired: "Expired",
  kybMandateStatusRevoked: "Revoked",
  kybMandateOverdue: "Ended",
  kybMandateUnknownPerson: "Person not found in the case",
  kybMandateNonClient: "The agent is not yet a client: the conversion remains to be done.",
  kybMandatePeriodFrom: "From",
  kybMandatePeriodTo: "to",
  kybMandatePeriodOpenEnded: "no end date",
  kybMandateDetailTitle: "Mandate detail",
  kybMandateDetailEmpty: "Select a mandate to see its detail.",
  kybMandateValidity: "Validity today",
  kybMandateValid: "Valid",
  kybMandateNotValid: "Not valid",
  kybMandateValidityLoading: "Checking validity",
  kybMandateValidityError: "Validity unavailable.",
  kybMandateCreatedBy: "Created by",
  kybMandateValidatedBy: "Validated by",
  kybMandateRevokedBy: "Revoked by",
  kybMandateRevocationReason: "Reason",
  kybMandateRevocationComment: "Comment",
  kybMandateParent: "Delegated from mandate",
  kybMandateClose: "Close",
  kybMandateNew: "New mandate",
  kybMandateCreateTitle: "Create a mandate",
  kybMandateCreateHint: "The mandate stays awaiting validation: it grants no power before the compliance officer validates it.",
  kybMandateFieldMandataire: "Agent (natural person of the case)",
  kybMandateFieldPerimeter: "Scope of the powers",
  kybMandateFieldAccount: "Covered account",
  kybMandateAccountAll: "All the accounts of the company",
  kybMandateAccountPlaceholder: "Choose an account",
  kybMandateErrAccount: "Choose the account covered by the mandate, or \"All the accounts\".",
  kybMandateErrOperations: "Tick at least one covered operation.",
  kybMandateOperationsUnavailable: "The operation types are not available: try again in a moment.",
  kybMandateFieldCeiling: "Amount ceiling",
  kybMandateFieldCurrency: "Currency (ISO code)",
  kybMandateFieldStart: "Start date",
  kybMandateFieldEnd: "End date (optional)",
  kybMandateFieldSignature: "Signature mode",
  kybMandateNoPerson: "No natural person in the case: add a representative first.",
  kybMandateSubmit: "Create the mandate",
  kybMandateCancel: "Cancel",
  kybMandateCreated: "Mandate created, awaiting validation.",
  kybMandateCreateError: "The mandate could not be created.",
  kybMandateCreateNotFound: "The case or the agent no longer exists.",
  kybMandateErrMandataire: "Choose the agent.",
  kybMandateErrPerimeterRequired: "Describe the scope of the powers.",
  kybMandateErrPerimeterTooLong: "The scope is limited to 2000 characters.",
  kybMandateErrCeiling: "The ceiling must be a number greater than 0.",
  kybMandateErrCurrency: "Three capital letters, for example XOF.",
  kybMandateErrStart: "Enter a valid start date.",
  kybMandateErrEndInvalid: "Enter a valid end date.",
  kybMandateErrEndBeforeStart: "The end date must be after the start date.",
  kybMandateDocsTitle: "Proof documents",
  kybMandateDocsEmpty: "No document yet.",
  kybMandateDocsLoadError: "The documents could not be loaded.",
  kybMandateDocsCount: "documents out of 10",
  kybMandateDocsAdd: "Add a document",
  kybMandateDocsType: "Proof type",
  kybMandateDocsValidity: "Legal validity date (optional)",
  kybMandateDocsFile: "File (PDF, PNG or JPEG)",
  kybMandateDocsSend: "Send",
  kybMandateDocsSent: "Document added.",
  kybMandateDocsSendError: "The document could not be sent.",
  kybMandateDocsDownload: "Open",
  kybMandateDocsDownloadError: "The document could not be opened.",
  kybMandateDocsTypePv: "Minutes (PV)",
  kybMandateDocsTypeProxy: "Power of attorney",
  kybMandateDocsTypeDelegation: "Delegation",
  kybMandateDocsNotPending: "Documents can only be added while the mandate awaits validation.",
  kybMandateDocsFull: "The limit of 10 documents is reached.",
  kybMandateDocsErrFile: "Choose a file.",
  kybMandateDocsErrFormat: "Only PDF, PNG or JPEG files are accepted.",
  kybMandateDocsErrEmpty: "The file is empty.",
  kybMandateDocsErrDate: "Enter a valid date.",
  kybMandateActTitle: "Validation by compliance",
  kybMandateActLoading: "Checking the conditions",
  kybMandateActEligibilityError: "The conditions could not be read.",
  kybMandateActBlockedTitle: "The mandate cannot be validated yet:",
  kybMandateActComment: "Comment (optional)",
  kybMandateActButton: "Validate the mandate",
  kybMandateActDone: "Mandate validated.",
  kybMandateActFailed: "The mandate could not be validated.",
  kybMandateActSod: "You cannot validate a mandate you created or documented.",
  kybMandateActConcurrent: "The agent already holds an active mandate over an overlapping period. Check the precedence before validating.",
  kybMandateGuardNoProof: "No proof document attached.",
  kybMandateGuardFileMissing: "No readable document in the storage.",
  kybMandateGuardProofExpired: "All the documents are past their legal validity.",
  kybMandateGuardMandantNotOperational: "The case of the company is not approved.",
  kybMandateGuardPeriodEnded: "The end date of the mandate has passed.",
  kybMandateGuardParentNotActive: "The parent mandate is not active.",
  kybMandateGuardUnknown: "Condition not met:",
  kybMandateRevokeButton: "Revoke",
  kybMandateRevokeTitle: "Revoke the mandate",
  kybMandateRevokeHint: "The accesses that depend on this mandate are suspended and their accounts closed. This cannot be undone: a new mandate is needed to grant powers again.",
  kybMandateRevokeReason: "Reason",
  kybMandateRevokeComment: "Justification",
  kybMandateRevokeCounter: "characters",
  kybMandateRevokeConfirm: "Revoke the mandate",
  kybMandateRevokeDone: "Mandate revoked.",
  kybMandateRevokeFailed: "The mandate could not be revoked.",
  kybMandateRevokeForbidden: "You cannot revoke a mandate you validated.",
  kybMandateRevokeAlready: "Mandate already revoked on",
  kybMandateRevokeBy: "by",
  kybMandateRevokeResult: "Accesses suspended / maintained / delegations revoked:",
  kybMandateRevokeErrReason: "Choose a reason.",
  kybMandateRevokeErrComment: "The justification is required.",
  kybMandateRevokeReasonsError: "The reasons could not be loaded.",
  kybMandateImpactTitle: "What the revocation removes",
  kybMandateImpactLoadError: "The impact could not be read.",
  kybMandateImpactNone: "No access depends on this mandate.",
  kybMandateImpactDeactivate: "will be suspended",
  kybMandateImpactMaintained: "maintained (covered by another active mandate)",
  kybMandateImpactDelegations: "Temporary delegations revoked with it",
  kybMandateImpactCounters: "to suspend / maintained",
  kybMandateReasonFinFonction: "End of the agent's duties",
  kybMandateReasonCessation: "Cessation of activity",
  kybMandateReasonDemande: "Request of the principal",
  kybMandateReasonPouvoirs: "Change of powers",
  kybMandateReasonConfiance: "Loss of trust",
  kybMandateReasonFraude: "Suspected fraud",
  kybMandateReasonErreur: "Mandate entered by mistake",
  kybMandateReasonAutre: "Other",
  kybDelegationTitle: "Temporary delegations",
  kybDelegationEmpty: "No delegation.",
  kybDelegationLoadError: "The delegations could not be loaded.",
  kybDelegationNew: "Delegate",
  kybDelegationCreateTitle: "Delegate part of the powers",
  kybDelegationCreateHint: "The delegation stays awaiting validation and grants no power before the compliance officer validates it. It ends with its parent mandate.",
  kybDelegationFieldDelegate: "Delegate (natural person of the case)",
  kybDelegationFieldPerimeter: "Scope (the parent scope if empty)",
  kybDelegationFieldOperations: "Delegated operations",
  kybDelegationOperationsNote: "The account is the mandate's. Only operations of the mandate can be delegated: untick the ones to withdraw.",
  kybDelegationLegacyNote: "This is an old mandate without a recorded account or operations: the delegation takes its scope as is.",
  kybDelegationPerimeterNote: "A restriction typed here cannot be checked by the machine: the validator will check it.",
  kybDelegationFieldCeiling: "Amount ceiling (at most the parent ceiling)",
  kybDelegationFieldStart: "Start date",
  kybDelegationFieldEnd: "End date",
  kybDelegationSubmit: "Create the delegation",
  kybDelegationCreated: "Delegation created, awaiting validation.",
  kybDelegationCreateError: "The delegation could not be created.",
  kybDelegationErrDelegate: "Choose the delegate.",
  kybDelegationErrCeiling: "The ceiling must be greater than 0 and at most the parent ceiling.",
  kybDelegationErrStart: "Enter a start date inside the period of the parent mandate.",
  kybDelegationErrEndRequired: "The end date is required.",
  kybDelegationErrEndPast: "The end date must be in the future.",
  kybDelegationErrEndBeforeStart: "The end date must be after the start date.",
  kybDelegationErrEndOutside: "The delegation cannot end after its parent mandate.",
  kybDelegationErrTooLong: "A delegation lasts 90 days at most.",
  kybContactTitle: "Contact for the access account",
  kybContactHint: "The e-mail receives the sign-in codes of the agent. Leave a field empty to clear it: the contact then falls back to the bank customer record.",
  kybContactEmail: "E-mail",
  kybContactPhone: "Phone",
  kybContactCurrent: "Current contact",
  kybContactNone: "No contact entered",
  kybContactFromBankFile: "taken from the bank customer file",
  kybContactEmailExample: "e.g. awa.kone@example.org",
  kybContactPhoneExample: "e.g. +2250102030405",
  kybContactSave: "Save the contact",
  kybContactSaved: "Contact saved.",
  kybContactPendingSaved: "Request recorded, waiting for validation by a second agent. The current contact stays in place meanwhile.",
  kybContactSaveError: "The contact could not be saved.",
  kybContactAlreadyPending: "A request is already waiting for this person.",
  kybContactErrEmail: "Enter a valid e-mail address (254 characters at most).",
  kybContactErrPhone: "Enter a valid phone number (6 to 20 digits, optional +).",
  kybContactErrUnchanged: "The contact is unchanged.",
  kybContactChangesTitle: "Contact change requests",
  kybContactChangesEmpty: "No request.",
  kybContactChangesLoadError: "The requests could not be loaded.",
  kybContactChangeProposed: "Proposed",
  kybContactChangeBy: "by",
  kybContactChangeCleared: "(cleared)",
  kybContactStatusPending: "Awaiting validation",
  kybContactStatusApproved: "Approved",
  kybContactStatusRejected: "Rejected",
  kybContactApprove: "Approve",
  kybContactReject: "Reject",
  kybContactDecisionApproveTitle: "Approve the contact change",
  kybContactDecisionRejectTitle: "Reject the contact change",
  kybContactDecisionProcedure: "Before approving, confirm the change through another channel than the one proposed (call the agent back on the number the bank already holds).",
  kybContactDecisionComment: "Comment",
  kybContactDecisionCommentRequired: "A comment is required to reject.",
  kybContactDecisionConfirm: "Confirm",
  kybContactDecisionApproved: "Contact change approved.",
  kybContactDecisionRejected: "Contact change rejected.",
  kybContactDecisionForbidden: "You cannot decide a request you made yourself.",
  kybContactDecisionFailed: "The decision could not be recorded.",
  kybAccessOpen: "Corporate access",
  kybAccessTitle: "Corporate access of the case",
  kybAccessBack: "Back to the case",
  kybAccessLoadError: "The accesses could not be loaded.",
  kybAccessNoCase: "This client has no active case.",
  kybAccessEmpty: "No corporate access yet.",
  kybAccessRetry: "Retry",
  kybAccessRefresh: "Refresh",
  kybAccessUserLabel: "Corporate access of",
  kybAccessStatusPending: "Account being created",
  kybAccessStatusActive: "Active",
  kybAccessStatusSuspended: "Suspended: mandate gone",
  kybAccessStatusSuspendedRecert: "Suspended: recertification not done",
  kybRecertMenu: "Recertification",
  kybRecertTitle: "Corporate access recertification",
  kybRecertSubtitle: "Confirm that each corporate access is still justified, or revoke it. Without a decision at the end of the grace period, the access is suspended automatically.",
  kybRecertTabPending: "To review",
  kybRecertTabSuspended: "Suspended accesses",
  kybRecertTabJournal: "Decision log",
  kybRecertRefresh: "Refresh",
  kybRecertSelected: "selected",
  kybRecertCertifySelection: "Certify the selection",
  kybRecertRevokeSelection: "Revoke the selection",
  kybRecertLoadError: "The recertification queue could not be loaded.",
  kybRecertRetry: "Retry",
  kybRecertEmpty: "No recertification in this view.",
  kybRecertSelectAll: "Select all",
  kybRecertSelectRow: "Select the recertification of",
  kybRecertColCompany: "Company",
  kybRecertColHolder: "Holder",
  kybRecertColAccess: "Access",
  kybRecertColDue: "Due date",
  kybRecertColGrace: "End of grace period",
  kybRecertColSituation: "Situation",
  kybRecertColDecidedBy: "Decided by",
  kybRecertColJustification: "Justification",
  kybRecertColActions: "Actions",
  kybRecertCertify: "Certify",
  kybRecertRevoke: "Revoke",
  kybRecertReactivate: "Reactivate",
  kybRecertStatusPending: "To decide",
  kybRecertStatusCertified: "Certified",
  kybRecertStatusRevoked: "Revoked",
  kybRecertStatusExpired: "Suspended automatically",
  kybRecertStatusCancelled: "Not applicable",
  kybRecertPhaseNotice: "Notice",
  kybRecertPhaseGrace: "Overdue, grace period",
  kybRecertPhaseOverdue: "Grace over: suspension imminent",
  kybRecertDialogCertifyTitle: "Certify the accesses",
  kybRecertDialogCertifyHint: "The access stays justified: a new recertification cycle starts. Your justification is recorded for each access.",
  kybRecertDialogRevokeTitle: "Revoke the accesses",
  kybRecertDialogRevokeHint: "The access is suspended and grants no right anymore. Your justification is recorded for each access.",
  kybRecertDialogReactivateTitle: "Reactivate the access",
  kybRecertDialogReactivateHint: "The access is reopened and starts a new cycle. The mandate must still be in force.",
  kybRecertJustification: "Justification",
  kybRecertJustificationHelp: "10 to 1000 characters. It is kept with the decision.",
  kybRecertJustificationRequired: "A justification of at least 10 characters is required.",
  kybRecertConfirm: "Confirm",
  kybRecertCancel: "Cancel",
  kybRecertDecided: "Decision recorded.",
  kybRecertReactivated: "Access reactivated.",
  kybRecertActionFailed: "The decision could not be recorded.",
  kybRecertSettingTitle: "Recertification setting",
  kybRecertSettingPeriod: "Period (months)",
  kybRecertSettingNotice: "Notice (days)",
  kybRecertSettingGrace: "Grace period (days)",
  kybRecertSettingDefault: "Default values of the configuration: no setting has been set.",
  kybRecertSettingBy: "Set by",
  kybRecertSettingEdit: "Edit",
  kybRecertSettingHint: "The change applies at the next run and only affects upcoming due dates: the grace period of an already open task does not change.",
  kybRecertSettingInvalid: "Each value must be an integer within its bounds, and the reason at least 10 characters long.",
  kybRecertSettingSaved: "Setting saved.",
  kybRecertSettingFailed: "The setting could not be saved.",
  kybMonitoringMenu: "KYB monitoring",
  kybMenuGroup: "KYB · Companies",
  kybMonitoringTitle: "KYB monitoring board",
  kybMonitoringSubtitle: "Current state of the portfolio: beneficial owners, enhanced due diligence and sensitive corporate accesses.",
  kybMonitoringRefresh: "Refresh",
  kybMonitoringSectionUbo: "Beneficial owners (UBO)",
  kybMonitoringSectionEdd: "Enhanced due diligence (EDD)",
  kybMonitoringSectionAccess: "Corporate accesses",
  kybMonitoringReadAt: "Read on",
  kybMonitoringDegraded: "The source did not answer: the indicators of this section are unavailable.",
  kybMonitoringUnavailable: "Unavailable",
  kybMonitoringSeeCases: "See the cases",
  kybMonitoringCasesTitle: "Cases",
  kybMonitoringCloseCases: "Close",
  kybMonitoringNoCases: "No case.",
  kybMonitoringMore: "Load more",
  kybMonitoringOpenCase: "Open",
  kybMonitoringUnknownCase: "Case without a known name",
  kybMonitoringLoadError: "The section could not be loaded.",
  kybMonitoringCasesError: "The list of cases could not be loaded.",
  kybMonitoringRetry: "Retry",
  kybRetentionMenu: "Retention",
  kybRetentionTitle: "KYB case retention",
  kybRetentionSubtitle: "Cases whose retention deadline is near or past. A case is never deleted automatically: deletion needs two signatures from different people.",
  kybRetentionWindowLabel: "Deadline within",
  kybRetentionDaysUnit: "days",
  kybRetentionRefresh: "Refresh",
  kybRetentionColCompany: "Company",
  kybRetentionColDeadline: "Deadline",
  kybRetentionColDaysLeft: "Days left",
  kybRetentionColStatus: "Status",
  kybRetentionOpen: "Open",
  kybRetentionEmpty: "No case in this window.",
  kybRetentionLoadError: "The register could not be loaded.",
  kybRetentionRetry: "Retry",
  kybRetentionUnknownCase: "Case without a known name",
  kybRetentionStatusActive: "Active",
  kybRetentionStatusDueSoon: "Due soon",
  kybRetentionStatusLegalHold: "Legal hold",
  kybRetentionStatusAwaiting: "Awaiting arbitration",
  kybRetentionStatusDeletionRequested: "Deletion requested",
  kybRetentionStatusDeletionAuthorized: "Deletion authorized",
  kybRetentionDetailTitle: "Case retention",
  kybRetentionDetailError: "The detail could not be loaded.",
  kybRetentionBaseDeadline: "Base deadline",
  kybRetentionEffectiveDeadline: "Effective deadline",
  kybRetentionHoldBy: "Hold placed by",
  kybRetentionDeletionBy: "Deletion requested by",
  kybRetentionNoSnapshot: "This case has no snapshot yet: no deadline exists and no decision is possible.",
  kybRetentionJournal: "Decision log",
  kybRetentionJournalEmpty: "No decision recorded.",
  kybRetentionTypeExtension: "Extension",
  kybRetentionTypeHold: "Hold placed",
  kybRetentionTypeRelease: "Hold released",
  kybRetentionTypeDeletionRequest: "Deletion requested",
  kybRetentionTypeDeletionAuthorization: "Deletion authorized",
  kybRetentionActionExtend: "Extend",
  kybRetentionActionHold: "Place a legal hold",
  kybRetentionActionRelease: "Release the hold",
  kybRetentionActionRequestDeletion: "Request deletion",
  kybRetentionActionAuthorizeDeletion: "Authorize deletion",
  kybRetentionHintExtend: "Moves the deadline to a date after the current one. Cancels a pending deletion request.",
  kybRetentionHintHold: "Forbids any deletion until the hold is released, whatever the deadline.",
  kybRetentionHintRelease: "Releases the hold. The person who placed it cannot release it.",
  kybRetentionHintRequestDeletion: "First signature: only possible when the deadline is past and no hold is active. A second person must authorize it.",
  kybRetentionHintAuthorizeDeletion: "Second signature, by someone other than the requester.",
  kybRetentionFieldReason: "Justification",
  kybRetentionFieldLegalBasis: "Legal basis",
  kybRetentionFieldNewDate: "New deadline",
  kybRetentionReasonRequired: "The justification is required.",
  kybRetentionLegalBasisRequired: "The legal basis is required.",
  kybRetentionDateInvalid: "The new deadline must be after the current one.",
  kybRetentionConfirm: "Confirm",
  kybRetentionCancel: "Cancel",
  kybRetentionActionFailed: "The decision could not be recorded.",
  kybRetentionDecided: "Decision recorded.",
  kybEvidenceTitle: "Evidence pack",
  kybEvidenceSubtitle: "Immutable snapshots of the case, hash-chained, and pack export for inspection.",
  kybEvidenceExportJson: "Export as JSON",
  kybEvidenceExportPdf: "Export as PDF",
  kybEvidenceExported: "Evidence pack exported.",
  kybEvidenceExportFailed: "The export could not be produced.",
  kybEvidenceLoadError: "The evidence pack could not be loaded.",
  kybEvidenceChainIntact: "Chain intact",
  kybEvidenceChainBroken: "Chain compromised: export is blocked",
  kybEvidenceChecked: "Snapshots checked",
  kybEvidenceNoSnapshot: "No snapshot: the first export takes one on demand.",
  kybEvidenceColStep: "Step",
  kybEvidenceColDate: "Captured on",
  kybEvidenceColAuthor: "Author",
  kybEvidenceColHash: "Hash",
  kybEvidenceColIntegrity: "Integrity",
  kybEvidenceSnapshotIntact: "Intact",
  kybEvidenceSnapshotAltered: "Altered",
  kybEvidenceExportsTitle: "Export log",
  kybEvidenceNoExport: "No export.",
  kybEvidenceOutcomeExported: "Exported",
  kybEvidenceOutcomeRefused: "Refused",
  kybAccessUserDeactivated: "User deactivated",
  kybAccessPendingHint: "The account is being created. It grants no right until it is confirmed.",
  kybAccessMandate: "Mandate",
  kybAccessProfileButton: "Profile",
  kybAccessWithoutTitle: "Active mandates without access",
  kybAccessCreate: "Create the access",
  kybAccessCreated: "Access created, awaiting the confirmation of the account.",
  kybAccessCreateError: "The access could not be created.",
  kybAccessNoContact: "This person has no contact: enter an e-mail on the representative card first.",
  kybAccessNoContactLink: "Go to the representatives",
  kybAccessReactivate: "Reactivate",
  kybAccessReactivateTitle: "Reactivate the user",
  kybAccessReactivateHint: "The user was closed when they lost every mandate. Reopening is an explicit decision of the compliance officer, recorded with its justification.",
  kybAccessReactivateComment: "Justification",
  kybAccessReactivateCommentRequired: "The justification is required.",
  kybAccessReactivateDone: "User reactivated.",
  kybAccessReactivateFailed: "The user could not be reactivated.",
  kybProfileTitle: "Rights profile",
  kybProfileLoadError: "The profile could not be loaded.",
  kybProfileNone: "No profile assigned: the access is refused everything.",
  kybProfileAssignedBy: "Assigned by",
  kybProfileRoles: "Roles",
  kybProfileAccounts: "Accounts (one per line)",
  kybProfileAccountsNote: "The accounts are checked by the back against those of the company.",
  kybProfileOperations: "Operations and ceiling per operation",
  kybProfileOperationCode: "Operation code",
  kybProfileOperationLimit: "Ceiling",
  kybProfileAddOperation: "Add an operation",
  kybProfileRemoveOperation: "Remove",
  kybProfileCountries: "Countries",
  kybProfileAddCountry: "Add a country",
  kybProfileCurrencies: "Currencies (ISO codes, separated by commas)",
  kybProfileMakerChecker: "Combining MAKER and CHECKER will be refused by the separation of duties.",
  kybProfileSave: "Save the profile",
  kybProfileSaved: "Profile saved.",
  kybProfileSaveError: "The profile could not be saved.",
  kybProfileReadOnly: "This access is suspended: its profile can no longer be changed.",
  kybProfileErrRoles: "Choose at least one role.",
  kybProfileErrAccounts: "Enter 1 to 200 accounts of 80 characters at most.",
  kybProfileErrOperations: "Enter at least one operation, each with a different code.",
  kybProfileErrLimit: "Each operation needs a ceiling greater than 0 (20 digits and 4 decimals at most).",
  kybProfileErrCountries: "Choose at least one country.",
  kybProfileErrCurrencies: "Enter at least one currency of three capital letters.",
  corpLoginTitle: "First sign-in of an agent",
  corpLoginIntro: "Reserved to the agents of a company who received an access. You will receive a code on the e-mail address the bank holds for you.",
  corpLoginLink: "First sign-in of a company agent? Set my password",
  corpLoginEmail: "E-mail address",
  corpLoginEmailInvalid: "Enter a valid e-mail address.",
  corpLoginSendCode: "Send me a code",
  corpLoginGeneric: "If this address is the one of an active access, a code has been sent. It is valid for 10 minutes.",
  corpLoginTooManyRequests: "Too many requests. Please try again later.",
  corpLoginCode: "Code received by e-mail",
  corpLoginCodeInvalid: "Enter the code received (4 to 8 digits).",
  corpLoginVerify: "Verify the code",
  corpLoginCodeWrong: "The code is wrong or expired.",
  corpLoginLocked: "Too many attempts. Please try again later.",
  corpLoginRestart: "Start again with another code",
  corpLoginPasswordRules: "Your password must contain:",
  corpLoginRuleLength: "at least 8 characters",
  corpLoginRuleLower: "a lowercase letter",
  corpLoginRuleUpper: "a capital letter",
  corpLoginRuleDigit: "a digit",
  corpLoginRuleSpecial: "a special character among @ $ ! % * ? & # + - _ = . , ; : / ( )",
  corpLoginNewPassword: "New password",
  corpLoginConfirmPassword: "Confirm the password",
  corpLoginMismatch: "The two passwords are different.",
  corpLoginSetPassword: "Set my password",
  corpLoginPolicyRefused: "The password does not meet the rules.",
  corpLoginTokenExpired: "The session expired. Start again from the beginning.",
  corpLoginUnavailable: "The service is unavailable. Please try again later.",
  corpLoginDone: "Password set.",
  corpLoginDoneHint: "Sign in with your e-mail address as your identifier.",
  corpLoginBack: "Back to the sign-in page",
  kybGridOpen: "Signature grids",
  kybGridTitle: "Signature grids of the case",
  kybGridBack: "Back to the case",
  kybGridNoCase: "This client has no active case.",
  kybGridLoadError: "The grids could not be loaded.",
  kybGridRetry: "Retry",
  kybGridEmpty: "No signature grid yet.",
  kybGridPropose: "Propose a grid",
  kybGridType: "Operation type",
  kybGridCurrency: "Currency",
  kybGridStatusPending: "Awaiting validation",
  kybGridStatusActive: "Active",
  kybGridStatusArchived: "Archived",
  kybGridRange: "Range",
  kybGridUnlimited: "no upper limit",
  kybGridSignatures: "signature(s)",
  kybGridCreatedBy: "Proposed by",
  kybGridValidatedBy: "Validated by",
  kybGridProposeTitle: "Propose a signature grid",
  kybGridProposeHint: "Half-open ranges: the lower bound is included, the upper one excluded. The first range starts at 0, each one starts where the previous stops, the last has no upper limit.",
  kybGridMin: "From (included)",
  kybGridMax: "To (excluded, empty = no limit)",
  kybGridRequired: "Signatures required",
  kybGridAddRange: "Add a range",
  kybGridRemoveRange: "Remove",
  kybGridSubmit: "Propose the grid",
  kybGridProposed: "Grid proposed, awaiting validation.",
  kybGridConflictsTitle: "The grid is not consistent:",
  kybGridProposeError: "The grid could not be proposed.",
  kybGridErrType: "Choose the operation type.",
  kybGridErrCurrency: "Three capital letters, for example XOF.",
  kybGridErrRanges: "Add at least one range.",
  kybGridErrRangeFormat: "Each range needs a minimum of 0 or more, a valid maximum if filled, and at least one signature.",
  kybGridActivate: "Validate",
  kybGridActivateTitle: "Validate the grid",
  kybGridActivateHint: "The quorum is checked again at this moment. Validating archives the grid that was active.",
  kybGridActivateComment: "Comment (optional)",
  kybGridActivateDone: "Grid validated.",
  kybGridActivateForbidden: "You cannot validate a grid you proposed.",
  kybGridActivateFailed: "The grid could not be validated.",
  kybGridSimTitle: "Simulator",
  kybGridSimHint: "Nothing is recorded: the simulation reads the active grid and the signatories in force.",
  kybGridSimAmount: "Amount",
  kybGridSimSigners: "Proposed signatories (optional)",
  kybGridSimRun: "Simulate",
  kybGridSimNoGrid: "No active grid for this operation type and currency.",
  kybGridSimError: "The simulation failed.",
  kybGridSimErrAmount: "Enter an amount of 0 or more.",
  kybGridSimRangeApplied: "Range applied",
  kybGridSimRequired: "Signatures required",
  kybGridSimAvailable: "Signatories in force",
  kybGridSimReachable: "The quorum can be reached.",
  kybGridSimUnreachable: "The quorum cannot be reached with the current mandates.",
  kybGridSimMet: "The proposed signatories reach the quorum.",
  kybGridSimNotMet: "The proposed signatories do not reach the quorum.",
  kybGridSimCounted: "counted",
  kybGridSimDiscarded: "discarded",
  kybCaseCountry: "Country",
  kybCaseLegalForm: "Legal form",
  kybCaseSubmittedBy: "Submitted by",
  kybCaseSubmittedAt: "Submitted on",
  kybCaseSlaPausedAt: "Review clock paused since",
  kybCaseSlaResumedAt: "Review clock resumed on",
  kybCaseReadyForValidation: "Ready for validation",
  kybCaseVigilanceTitle: "Points of vigilance",
  kybNextTitle: "Next step",
  kybNextEntryOpen: "The dossier is being entered: finish the entry then submit it.",
  kybNextEntryOpenOther: "The dossier is being entered by the agent.",
  kybNextEntryResume: "Resume the entry",
  kybNextAwaitingClient: "The customer must complete the requested documents. Once received, submit the dossier again.",
  kybNextAwaitingClientOther: "The dossier is waiting for the customer's documents.",
  kybNextSeePieces: "See the documents",
  kybNextQualifyHits: "screening match(es) to qualify: homonym or right person.",
  kybNextControlPieces: "received document(s) to check.",
  kybNextVerifyOwners: "The beneficial owners are not verified.",
  kybNextMarkReady: "The instruction is complete: mark the dossier ready for validation.",
  kybNextInstructionOther: "The dossier is under instruction by the compliance team.",
  kybNextGoQualify: "Qualify",
  kybNextGoControl: "Check",
  kybNextGoVerify: "Verify",
  kybNextGoInstruction: "Open the instruction",
  kybNextValidateL1: "The dossier is ready: validate it (level 1).",
  kybNextValidateL1Other: "The dossier is waiting for the level 1 validation.",
  kybNextGoValidate: "Validate",
  kybNextDecide: "The level 1 validation is done: decide on the dossier (approval, restrictions, rejection or hold).",
  kybNextDecideEdd: "An EDD is required: it must be approved before the dossier is approved.",
  kybNextDecideOther: "The dossier is waiting for the decision of the compliance officer.",
  kybNextGoDecide: "Decide",
  kybNextOnHold: "The dossier is on regulatory hold: a new decision is possible once it is lifted.",
  kybNextApproved: "The dossier is approved: follow the account opening, the mandates and the accesses.",
  kybNextGoAccess: "Mandates and accesses",
  kybNextClosed: "The dossier is closed: nothing to do.",
  kybCaseTimelineTitle: "Case history",
  kybCaseTimelineEmpty: "No entry yet.",
  kybCaseTimelineError: "The history could not be loaded.",
  kybCaseTimelineActor: "By",
  kybCaseTimelineJustification: "Justification",
  kybCaseTimelineCritical: "Critical",
  kybCaseTimelinePage: "Page",
  kybInstructionTitle: "Case review",
  kybInstructionActionFailed: "The action could not be completed.",
  kybInstructionCommentLabel: "Review comment",
  kybInstructionCommentPlaceholder: "Observation on the case (kept in the case history)",
  kybInstructionCommentButton: "Add the comment",
  kybInstructionCommentRequired: "The comment is required.",
  kybInstructionCommentAdded: "Comment added to the case.",
  kybHitsTitle: "Screening hits of the related persons",
  kybHitsHint: "A hit to qualify blocks the decision of the case. Conclude with a justification: it is kept in the log with your identifier.",
  kybHitsLoadError: "The screening hits could not be loaded.",
  kybHitToQualify: "To qualify",
  kybHitConfirmed: "Confirmed match",
  kybHitCleared: "False positive cleared",
  kybHitLegalParty: "Intermediate company",
  kybHitEntity: "Company of the case",
  kybHitDecisionFalsePositive: "False positive",
  kybHitDecisionConfirmed: "Confirmed match",
  kybHitJustification: "Justification",
  kybHitJustificationPlaceholder: "Why this conclusion? (at least 10 characters)",
  kybHitSave: "Save the conclusion",
  kybHitSaved: "Conclusion saved.",
  kybHitDecisionRequired: "Choose a conclusion.",
  kybHitCandidatesTitle: "Which match is the person of the case?",
  kybHitCandidateRequired: "Designate the match that describes the person.",
  kybHitCandidatePep: "PEP",
  kybHitCandidateSanction: "Sanction",
  kybHitCandidateBirth: "Born on",
  kybHitCandidateNationality: "Nationality",
  kybHitCandidateScore: "Score",
  kybHitCandidateShowDetail: "Show details",
  kybHitCandidateHideDetail: "Hide details",
  kybHitCandidateSuggested: "Suggested by the provider",
  kybHitCandidateCategory: "Category",
  kybHitCandidatePlaceOfBirth: "Place of birth",
  kybHitCandidateResidence: "Residence",
  kybHitCandidateLists: "Lists",
  kybHitCandidateAssociates: "Associated people",
  kybHitCandidateSources: "Sources",
  kybHitCandidateNoDetail: "The provider knows nothing more about this candidate.",
  kybHitSubjectTitle: "Person of the dossier",
  kybHitSubjectUnknown: "not provided",
  kybHitCompareIntro: "Compare each provider match to the person of the dossier, then pick the right one or discard them all.",
  kybHitIsPerson: "It is the person",
  kybHitIsNotAny: "None is the person (homonyms)",
  kybHitChosen: "Selected",
  kybHitChosenNone: "All discarded: false positive",
  kybHitChangeChoice: "Change",
  kybHitStateMatch: "matching",
  kybHitStateDiffer: "different",
  kybHitStateUnknown: "cannot verify",
  kybHitSourcesOf: "Sources of the alert",
  kybHitSubjectRole: "Role",
  kybHitNoIdentity: "The provider gives no birth date for this profile: nothing to compare.",
  kybHitSourceCountry: "Source country",
  kybHitSourceCountryHelp: "Attached to the alert, not to the person: it is not their nationality.",
  kybHitScoreHelp: "Strength of the match computed by the provider between the screened person and this profile, from 0 to 100%. A high score does not prove it is the right person: compare the birth date and the sources.",
  kybHitLegend: "Matching: same birth date as the dossier. Different: different date, a sign of a homonym. Cannot verify: information missing on one side, or a different format.",
  kybHitStateUnknownHelp: "The dossier or the provider does not have this information, or it is not written in the same format: it can neither confirm nor rule out.",
  kybHitColFile: "Dossier",
  kybHitColProvider: "Provider",
  kybHitNotProvided: "not provided",
  kybHitScoreCaption: "provider match",
  kybHistoryCount: "Changes",
  kybHistoryFilterField: "Field",
  kybHistoryFilterAllFields: "All fields",
  kybHistoryFilterSource: "Origin",
  kybHistoryFilterAllSources: "All origins",
  kybHistoryFilterActor: "Author",
  kybHistoryFilterActorPlaceholder: "Login",
  kybHistoryFilterFrom: "From",
  kybHistoryFilterTo: "To",
  kybHistoryFilterReset: "Reset",
  kybHistoryNoResult: "No change matches these filters.",
  kybHistoryMore: "Show more",
  kybHistoryChangeOne: "change",
  kybHistoryChangeMany: "changes",
  kybHistoryChange: "Change",
  kybFilterSearchPlaceholder: "Company name or case key",
  kybFilterAllStatuses: "All statuses",
  kybFilterNoMatch: "No result for these filters.",
  kybFilterReset: "Reset",
  onboardingLoadingProspect: "Loading the prospect",
  requestCreateProspect: "Prospect creation",
  kybMandateSearchPlaceholder: "Mandatary name or scope",
  newRequestSubtitle: "Pick the request to open. Greyed-out requests are not available yet.",
  kybRecertSearchPlaceholder: "Company, holder or case key",
  kybGuideButton: "Page guide",
  kybGuideGotIt: "Got it",
  kybRecertGuideTitle: "What is this page for?",
  kybRecertGuideIntro: "Every corporate access granted to a company representative must be reconfirmed at regular intervals (every 6 months by default). This page lists the accesses whose reconfirmation is due or late, and lets you decide.",
  kybRecertGuideTabs: "The three views",
  kybRecertGuideTabsText: "\"To process\": decisions awaiting you. \"Suspended accesses\": accesses blocked for lack of a decision, which can be reactivated. \"Decision log\": the history, which cannot be changed.",
  kybRecertGuideCertify: "Certify",
  kybRecertGuideCertifyText: "The access remains justified: a new 6-month cycle starts. A justification is required.",
  kybRecertGuideRevoke: "Revoke",
  kybRecertGuideRevokeText: "The access is no longer justified: it is suspended and grants no right. A justification is required.",
  kybRecertGuideGrace: "Grace period",
  kybRecertGuideGraceText: "Time left after the due date to decide. Once it has passed without a decision, the access is suspended automatically.",
  kybRecertGuideSituation: "Situation column",
  kybRecertGuideSituationText: "It shows where the due date stands. Hover each pill to read what it means.",
  kybRecertHintPhaseNotice: "The due date is approaching: nothing urgent, you can already decide.",
  kybRecertHintPhaseGrace: "The due date has passed but the access stays active until the end of the grace period. Decide before then.",
  kybRecertHintPhaseOverdue: "The grace period is over: without a decision, the access will be suspended automatically on the next daily run.",
  kybRecertHintStatusPending: "A compliance decision is awaited on this access.",
  kybRecertHintStatusCertified: "The access was confirmed as justified: a new cycle has started.",
  kybRecertHintStatusRevoked: "The access was withdrawn by compliance: it grants no right any more.",
  kybRecertHintStatusExpired: "No decision within the grace period: the access was suspended automatically. It can be reactivated from \"Suspended accesses\".",
  kybRecertHintStatusCancelled: "The recertification is no longer relevant, for example because the access disappeared with its mandate.",
  kybAccessHintPending: "The user's account is being created: it cannot be used yet.",
  kybAccessHintActive: "The user can sign in and act according to their profile.",
  kybAccessHintSuspended: "The mandate that justified this access no longer exists (revoked or expired): the access is blocked.",
  kybAccessHintSuspendedRecert: "The recertification was not done in time: the access is blocked until it is reactivated.",
  kybRecertHintColDue: "Date by which the access must be reconfirmed.",
  kybRecertHintColGrace: "Last day to decide before automatic suspension.",
  kybRecertHintColAccess: "Current state of the user's corporate account.",
  kybRecertHintColSituation: "Where the due date stands. Hover a pill for details.",
  kybMonitoringViewLedger: "Ledger",
  kybMonitoringViewChart: "Chart",
  kybMonitoringViewLabel: "Display",
  kybCaseVerifyBeneficiaries: "Verify the beneficial owners",
  customerKindColumn: "Case",
  customerKindKyc: "KYC",
  customerKindKyb: "KYB",
  customerKindKycHint: "Individual customer case (KYC)",
  customerKindKybHint: "Company case (KYB)",
  customerKindFilterLabel: "Scope",
  customerKindFilterAll: "KYC and KYB",
  customerKindFilterKyc: "KYC: individuals",
  customerKindFilterKyb: "KYB: companies",
  documentFreeTitle: "Upload another document",
  documentFreeHint: "Document requested outside the list above: pick its type, then the file.",
  documentFreeTypeLabel: "Document type",
  documentFreeChoose: "Choose a type",
  documentFreeUpload: "Choose the file",
  documentFreeOther: "Other document (manual entry)",
  documentFreeOtherLabel: "Document name",
  kybCaseStagesTitle: "Case progress",
  kybStageSubmission: "Submission",
  kybStageInstruction: "Review",
  kybStageValidation: "L1 validation",
  kybStageDecision: "Decision",
  kybStageDetailBy: "By",
  kybStageDetailAssignedTo: "Assigned to",
  kybStageDetailUnassigned: "Not assigned yet",
  kybStageDetailRecorded: "Recorded:",
  kybStageDetailReadyBy: "Ready, by",
  kybStageDetailAwaitingClient: "Awaiting the client: review paused",
  kybStageDetailAwaitingL1: "Awaiting an L1 validator",
  kybStageDetailValidatedBy: "Validated by",
  kybStageDetailAwaitingDecision: "Awaiting the compliance manager's decision",
  kybStageDetailRegulatoryHold: "On regulatory hold",
  kybInstructionStateValidated: "Validated at L1",
  kybInstructionStateSuspended: "Review paused",
  kybValidationDoneBy: "This case was validated at L1 by",
  serviceUnavailableTitle: "The service is temporarily unavailable",
  serviceUnavailableHint: "Your data is safe. Check your connection and try again in a moment; if the problem persists, contact support.",
  historySearchLabel: "Search",
  historySearchPlaceholder: "Title, author or detail",
  historyNoResult: "Nothing matches these filters.",
  historyCount: "Entries",
  historyEntryOne: "event",
  historyEntryMany: "events",
  eddHistoryEmpty: "No event has been recorded yet.",
  verdictHistoryTitle: "Check history",
  verdictHistoryLoadError: "The check history could not be loaded.",
  verdictHistoryRetry: "Retry",
  verdictHistoryEmpty: "No check has been evaluated for this client yet.",
  riskEntityHistoryFilterAction: "Action",
  kybComplementTypesMenu: "Complementary documents",
  kybComplementTypesTitle: "KYB complementary documents",
  kybComplementTypesSubtitle: "The documents the review can ask a client for on top of a case. A document is never deleted: once disabled it is no longer offered but stays readable in requests already sent.",
  kybComplementTypesGuideTitle: "What is this page for?",
  kybComplementTypesGuideIntro: "When an analyst asks a client for documents, they pick them from this list, or type another one by hand. You decide here what is offered.",
  kybComplementTypesGuideAdd: "Add",
  kybComplementTypesGuideAddText: "Pick a short code (capitals and underscores, permanent) and a readable label: the label is what the analyst and the manager will see.",
  kybComplementTypesGuideDisable: "Disable",
  kybComplementTypesGuideDisableText: "A disabled document disappears from the offered list without erasing past requests. You can enable it again at any time.",
  kybComplementTypesGuideOrder: "Order",
  kybComplementTypesGuideOrderText: "Documents are offered from the smallest rank to the largest. Put the most common first.",
  kybComplementTypesAdd: "Add a document",
  kybComplementTypesColLabel: "Label",
  kybComplementTypesColCode: "Code",
  kybComplementTypesColOrder: "Rank",
  kybComplementTypesColState: "State",
  kybComplementTypesColActions: "Actions",
  kybComplementTypesActive: "Offered",
  kybComplementTypesInactive: "Disabled",
  kybComplementTypesHintActive: "This document is offered to the review.",
  kybComplementTypesHintInactive: "This document is no longer offered; requests already sent still show it.",
  kybComplementTypesDisable: "Disable",
  kybComplementTypesEnable: "Enable",
  kybComplementTypesRename: "Edit",
  kybComplementTypesEmpty: "No document in the catalogue.",
  kybComplementTypesLoadError: "The catalogue could not be loaded.",
  kybComplementTypesRetry: "Retry",
  kybComplementTypesDialogAddTitle: "Add a document",
  kybComplementTypesDialogEditTitle: "Edit the document",
  kybComplementTypesFieldCode: "Code",
  kybComplementTypesFieldCodeHelp: "Capitals, digits and underscores, 2 to 60 characters. Permanent.",
  kybComplementTypesFieldLabel: "Label",
  kybComplementTypesFieldOrder: "Display rank",
  kybComplementTypesInvalid: "A valid code (capitals, digits, underscores) and a label are required.",
  kybComplementTypesSave: "Save",
  kybComplementTypesCancel: "Cancel",
  kybComplementTypesSaved: "Document saved.",
  kybComplementTypesEnabled: "Document enabled.",
  kybComplementTypesDisabled: "Document disabled.",
  kybComplementTypesFailed: "The operation could not be saved.",
  kybComplementTypesSearch: "Document label or code",
  kybInstructionStateInProgress: "Under review",
  kybInstructionStateReady: "Ready for validation",
  kybInstructionNotesTitle: "Review notes",
  kybInstructionNotesHelp: "Keep a record of your analysis. The note is dated, signed and shown in the history; it can no longer be edited.",
  kybInstructionOwnerTitle: "Reviewer",
  kybInstructionAssignedTo: "Instruction assigned to",
  kybInstructionChangeOwner: "Change the instructor",
  kybInstructionKeepOwner: "Keep this instructor",
  kybInstructionOwnerHelp: "Pick the analyst who takes over the review. The history keeps every reviewer: none of them will be able to validate the case (segregation of duties).",
  kybInstructionOwnerBranchFilter: "Branch",
  kybInstructionOwnerAnalyst: "Analyst",
  kybInstructionOwnerChoose: "Choose an analyst",
  kybInstructionBranchRelevant: "Case branch and head office",
  kybInstructionBranchAll: "All branches",
  kybInstructionBranchHeadOffice: "Head office (no branch)",
  kybInstructionGroupCaseBranch: "Case branch",
  kybInstructionGroupHeadOffice: "Head office",
  kybInstructionGroupOther: "Other branches",
  kybInstructionOwnerNone: "No analyst matches this filter.",
  kybInstructionOwnerLoadFailed: "The list of analysts could not be read: enter the analyst's login.",
  kybInstructionOwnerManual: "Analyst login",
  kybInstructionComplementHeading: "Ask the client for documents",
  kybInstructionComplementHelp: "The case goes back to \"awaiting client\", the review deadline is paused and the relationship manager is told which documents are requested.",
  kybInstructionPiecesLegend: "Documents to provide",
  kybInstructionPieceMissing: "Missing",
  kybInstructionPieceOther: "Other document",
  kybInstructionPieceOtherPlaceholder: "Name of the requested document",
  kybInstructionPieceAdd: "Add",
  kybInstructionPieceRemove: "Remove",
  kybInstructionPiecesSelected: "document(s) requested",
  kybInstructionComplementSend: "Send the request to the client",
  kybInstructionReadyHeading: "Move on to validation",
  kybInstructionReadyHelp: "When the review is done and every mandatory document is received, mark the case ready: another manager can then validate it.",
  kybMonitoringOutOf: "of",
  kybMonitoringShareOfTotal: "of total",
  kybMonitoringShareOfOpen: "of open EDD",
  kybMonitoringSegmentClosed: "Closed",
  kybMonitoringSegmentOpenOnTime: "Open, on time",
  kybMonitoringSegmentOverdue: "Open, overdue",
  kybMonitoringSegmentOtherStates: "Other states (active, suspended for recertification)",
  kybMonitoringSegmentPending: "Pending provisioning",
  kybMonitoringSegmentSuspended: "Suspended (mandate revoked or expired)",
  kybMonitoringCasesHint: "Open a case to review it.",
  kybMonitoringColCase: "Company",
  kybMonitoringColKey: "Case key",
  kybMonitoringGuideTitle: "What is this page for?",
  kybMonitoringGuideIntro: "It shows the state of the KYB portfolio at the time of reading: beneficial owners, enhanced due diligence and sensitive corporate accesses.",
  kybMonitoringGuideSections: "The sections",
  kybMonitoringGuideSectionsText: "Each section only appears if your profile may read it. Its reading time is shown at its top right.",
  kybMonitoringGuideChart: "Ledger or chart",
  kybMonitoringGuideChartText: "The ledger details each indicator with its definition; the chart compares the figures at a glance, bars scaled within the section.",
  kybMonitoringGuideCases: "See the cases",
  kybMonitoringGuideCasesText: "Click a figure or \"See cases\" to open the list of counted cases, then open one.",
  kybMonitoringGuideUnavailable: "\"Unavailable\"",
  kybMonitoringGuideUnavailableText: "An unavailable indicator is not a zero: the source could not be read, and the reason is given.",
  kybHitJustificationRequired: "A justification is required (at least 10 characters).",
  kybHitActionFailed: "The conclusion could not be saved.",
  kybHitConclusionLabel: "Conclusion",
  kybInstructionAssignLabel: "Assign to an analyst (login)",
  kybInstructionAssignButton: "Assign",
  kybInstructionAssigneeRequired: "The analyst login is required.",
  kybInstructionAssigned: "Review assigned.",
  kybInstructionComplementTitle: "Request a complement",
  kybInstructionComplementPieces: "Required documents (one per line)",
  kybInstructionComplementMessage: "Message to the relationship manager (optional)",
  kybInstructionComplementButton: "Request the complement",
  kybInstructionPiecesRequired: "At least one required document is needed.",
  kybInstructionComplementRequested: "Complement requested, the case now waits for the client.",
  kybInstructionReadyButton: "Mark ready for validation",
  kybInstructionReadyAlready: "The case is ready for validation.",
  kybInstructionClosed: "The instruction is closed: the dossier is ready and waits for level 1 validation. It cannot be changed until it is reopened.",
  kybReopenButton: "Reopen the instruction",
  kybReopenConfirm: "Reopen",
  kybReopenReasonLabel: "Reason (required, recorded in the dossier log)",
  kybReopenEffect: "The dossier is no longer ready for validation: it goes back under instruction, where it can be commented, reassigned and pieces requested again. It must be marked ready again.",
  kybValidationSendBack: "Send back to instruction",
  kybInstructionMarkedReady: "Case marked ready for validation.",
  kybValidationTitle: "Four-eyes validation (L1)",
  kybValidationJustificationLabel: "Justification of the validation",
  kybValidationJustificationRequired: "The justification is required.",
  kybValidationNotReady: "The reviewer must mark the case ready before it can be validated.",
  kybValidationPrereqTitle: "Before validating",
  kybValidationPrereqReady: "The instructor marked the dossier ready for validation",
  kybValidationPrereqIndependent: "You are neither the assigned instructor nor the one who marked the dossier ready",
  kybValidationPrereqNotIndependent: "You contributed to the instruction: another officer must validate (segregation of duties)",
  kybValidationPrereqIndependentHelp: "The server checks every contribution to the instruction (notes, conclusions, assignment): a refusal is logged.",
  kybValidationPrereqComment: "Justification of the validation entered",
  kybValidationPrereqSeeInstruction: "See the instruction",
  kybValidationButton: "Validate the case",
  kybValidationDone: "Case validated (four eyes).",
  kybDecisionTitle: "Compliance decision (P4)",
  kybDecisionOptionApprove: "Approve",
  kybDecisionOptionApproveWithRestrictions: "Approve with restrictions",
  kybDecisionOptionReject: "Reject",
  kybDecisionOptionRegulatoryHold: "Put on regulatory hold",
  kybDecisionJustificationLabel: "Justification of the decision",
  kybDecisionJustificationRequired: "The justification is required.",
  kybDecisionRestrictionsLabel: "Restrictions applied",
  kybDecisionRestrictionsRequired: "The restrictions are required for this decision.",
  kybDecisionChooseOption: "Choose a decision.",
  kybDecisionConfirmButton: "Confirm the decision",
  kybDecisionDone: "Decision recorded.",
  kybDecisionEligibilityError: "The decision conditions could not be read.",
  kybDecisionBlockedTitle: "Approval is not possible yet:",
  kybGuardNotValidatedL1: "The case has not been through the four-eyes validation (L1).",
  kybGuardScreeningPending: "The screening of a party of the case is not finished.",
  kybGuardScreeningHitUnqualified: "A screening hit has not been qualified.",
  kybGuardSanctionsConfirmedMatch: "A sanctions match is confirmed.",
  kybGuardRccmNotVerified: "No RCCM registration is verified.",
  kybGuardEddInProgress: "The required EDD case is not approved yet.",
  kybGuardEddRejected: "The EDD case was rejected or closed without approval.",
  kybGuardGo: "Go",
  kybGuardGoEdd: "Open the EDD dossiers",
  kybCbsTitle: "Account opening at the CBS",
  kybCbsStateUnavailable: "Sending to the CBS is disabled (bank contract not delivered yet).",
  kybCbsStateWaiting: "The opening at the CBS is waiting to be sent or retried.",
  kybCbsStatePushed: "The opening is confirmed at the CBS.",
  kybCbsStateAbandoned: "The CBS opening failed for good: fix the cause, then restart it.",
  kybCbsPushStatusPending: "To send",
  kybCbsPushStatusRetry: "To retry",
  kybCbsPushStatusUnknown: "Outcome unknown, checked before any resend",
  kybCbsPushStatusDone: "Done",
  kybCbsPushStatusDead: "Abandoned, manual retry possible",
  kybCbsAttempts: "Attempts",
  kybCbsNextAttempt: "Next attempt",
  kybCbsLastError: "Last failure",
  kybCbsReference: "CBS operation reference",
  kybCbsReferenceHelp: "Operation identifier at the CBS, to find it on the bank side.",
  kybCbsCopy: "Copy the reference",
  kybCbsCopied: "Reference copied.",
  kybCbsPushedAt: "Confirmed on",
  kybCbsRetryButton: "Retry the opening",
  kybCbsRetried: "The opening was put back in the queue.",
  kybCbsNone: "No opening is queued for this case.",
  kybCbsReadError: "The CBS opening state could not be read.",
  uboPartiesTitle: "Holders and controlling parties",
  uboPartiesEmpty: "No party declared yet.",
  uboAddPersonTitle: "Add a natural person",
  uboAddLegalPartyTitle: "Add an interposed company",
  uboRoleLabel: "Role",
  uboRolePlaceholder: "Choose a role",
  uboLastName: "Last name",
  uboFirstName: "First name",
  uboBirthDate: "Birth date",
  uboNationality: "Nationality",
  uboDenomination: "Company name",
  uboLegalForm: "Legal form",
  uboRegistration: "Registration number",
  uboCountry: "Country",
  uboAddPersonButton: "Add the person",
  uboAddLegalPartyButton: "Add the company",
  uboPersonFieldsRequired: "Role, last name and first name are required.",
  uboLegalPartyFieldsRequired: "Role and company name are required.",
  uboDuplicateTitle: "A similar person already exists",
  uboDuplicateReuse: "Reuse",
  uboDuplicateCreateAnyway: "Create anyway",
  uboDuplicateCancel: "Cancel",
  uboEdgesTitle: "Holding links",
  uboEdgesEmpty: "No link declared yet.",
  uboEdgeOwner: "Holder",
  uboEdgeTarget: "Held entity",
  uboEdgeTargetRoot: "The company of the case",
  uboEdgeNature: "Nature",
  uboNatureCapital: "Share capital",
  uboNatureVoting: "Voting rights",
  uboNatureControl: "Other control",
  uboEdgePercentage: "Percentage (%)",
  uboEdgeControlBasis: "Basis of the control",
  uboEdgeAddButton: "Add the link",
  uboEdgeRemoveButton: "Remove",
  uboEdgeFieldsRequired: "Choose a holder, a nature and the percentage (or the control basis).",
  uboEdgePercentageInvalid: "The percentage must be above 0 and at most 100, with three decimals at most.",
  shareCapitalInvalid: "The share capital must be a whole number above 0.",
  entrepriseFieldTooLong: "This value is too long.",
  declarantEmail: "Declarant email",
  declarantPhone: "Declarant phone",
  declarantContactReadOnly: "The declarant is entered and verified when the prospect is created: here it is read only. The company email and phone, however, are saved here.",
  representativeExistingCustomer: "Bank customer:",
  representativeExistingCustomerNote: "Their identity, date of birth, nationality and profession are taken from their record: only the role is to be entered.",
  uboAnalysisTitle: "Beneficial owners and opacity",
  uboAnalysisRefresh: "Refresh the analysis",
  uboExportPdf: "Export PDF",
  uboExportJson: "Export JSON",
  uboOwnersEmpty: "No beneficial owner computed yet.",
  uboOriginHolding: "By holding",
  uboOriginControl: "By control",
  uboOriginDefaultDirector: "Default director",
  uboCapitalPercent: "Effective capital",
  uboVotePercent: "Effective votes",
  uboThreshold: "Threshold",
  uboOpacityScore: "Opacity score",
  uboOpacityEddRecommended: "An enhanced review is recommended.",
  uboOpacityLevelLow: "Low",
  uboOpacityLevelMedium: "Medium",
  uboOpacityLevelHigh: "High",
  uboFallbackTitle: "Director fallback",
  uboFallbackHint: "Use it only when no beneficial owner can be established. A compliance officer (P4) must validate it.",
  uboFallbackDirector: "Director retained",
  uboFallbackJustification: "Why no beneficial owner can be established (30 characters minimum)",
  uboFallbackSaveButton: "Save the draft",
  uboFallbackSubmitButton: "Submit for validation",
  uboFallbackFieldsRequired: "Choose the director and give a justification.",
  uboFallbackStatus: "Status",
  uboFallbackStatusDraft: "Draft",
  uboFallbackStatusSubmitted: "Waiting for P4 validation",
  uboFallbackStatusValidated: "Validated",
  uboFallbackStatusRejected: "Rejected, the case stays blocked",
  uboFallbackStatusObsolete: "Obsolete, a beneficial owner appeared",
  uboFallbackDecisionReason: "Reason of the decision",
  kybFallbackDecisionTitle: "Director fallback to decide",
  kybFallbackDecisionApprove: "Validate the fallback",
  kybFallbackDecisionReject: "Reject the fallback",
  kybFallbackDecisionReasonLabel: "Reason (required to reject)",
  kybFallbackDecisionReasonRequired: "A reason is required to reject the fallback.",
  kybFallbackDecisionDone: "Fallback decision recorded.",
  accountOpeningTitle: "Final recap & account opening",
  accountOpeningRecapCompanyName: "Company",
  accountOpeningRecapLegalForm: "Legal form",
  accountOpeningRecapShareholders: "Shareholders",
  accountOpeningRecapScreening: "Screening",
  accountOpeningRecapScoreDecision: "Score · Decision",
  accountOpeningRecapSignatoriesTitle: "Signatories to register",
  accountOpeningBlockedMessage:
    "The account can only be created once the case has been approved.",
  accountOpeningCreateButton: "Create the account",
  accountOpeningConfirmTitle: "Create the account?",
  accountOpeningConfirmDescription:
    "This action is irreversible: the account and its signatories will be created in Orion.",
  accountOpeningConfirmAction: "Confirm creation",
  accountOpeningSuccessMessage: "Account created successfully.",
  accountOpeningAccountNumberLabel: "Account number",
  accountOpeningSignatoriesLabel: "Signatories",

  stepEvidencePack: "Evidence pack",
  evidencePackTitle: "Evidence pack",
  evidencePackDescription:
    "Exportable recap of the case, in compliance with the applicable instruction, including the next periodic review date.",
  evidencePackGenerateButton: "Generate & export the evidence pack",
  evidencePackLoading: "Generating the evidence pack…",
  evidencePackComplianceStatement:
    "This evidence pack complies with BCEAO Instruction n°003-03-2025.",
  evidencePackReferenceLabel: "Reference",
  evidencePackGeneratedAtLabel: "Generated on",
  evidencePackNextReviewDateLabel: "Next periodic review",
  evidencePackDownloadButton: "Download (PDF)",
  evidencePackRegenerateButton: "Regenerate",
  evidencePackContinueButton: "Open the account",
  evidencePackHashLabel: "Hash",
  evidencePackSectionIdentification: "Client identification",
  evidencePackSectionRegistration: "Registration & tax",
  evidencePackSectionRepresentation: "Legal representative & mandates",
  evidencePackSectionShareholding: "Shareholding & UBO",
  evidencePackSectionDocuments: "Documents received",
  evidencePackSectionScreening: "Screening results",
  evidencePackSectionRiskScore: "Risk score",
  evidencePackSectionDecision: "KYB decision",
  evidencePackSectionRestrictions: "Restrictions",
  evidencePackSectionAuditTrail: "Audit trail",
  evidencePackSectionStatusVerified: "Verified",
  evidencePackSectionStatusComplete: "Complete",
  evidencePackSectionStatusPartial: "Partial",
  evidencePackSectionStatusMissing: "Missing",
  evidencePackDetailVerified: "Verified",
  evidencePackDetailNotVerified: "Not verified",
  evidencePackDetailMissing: "Missing",
  evidencePackDetailComplete: "Complete",
  evidencePackDetailPartial: "Partial",
  evidencePackDetailHitConfirmed: "Confirmed hit",
  evidencePackDetailNone: "None",
  evidencePackDetailRestrictionsApplied: "Restrictions applied",
  evidencePackDetailAwaitingDecision: "Awaiting decision",

  request: "Request",
  partsApproval: "Parts & approvals",
  metadataOcr: "Metadata & OCR",
  summaryValidation: "Summary & validation",
  reviewSummaryTitle: "Summary — Client creation validation",
  verifyBeforeCreate: "Verify all information before confirming creation",
  screeningAndProfile: "Screening & Profile",
  screeningRule: "Rule",
  screeningDetail: "Detail",
  noScreeningRules: "No screening rules",
  screeningRulesPending: "Checks in progress, results are on their way...",
  screeningRulesUnavailable: "Screening checks are unavailable right now. Try again shortly or report it to support.",
  screeningProvider: "Source",
  screeningAdvisoryNotice: "The external VNeurone check is advisory: its verdict is recorded and passed on to compliance, but it does not block onboarding. The final decision is notified separately.",
  screeningExternalNotStarted: "The external eligibility check has not answered yet. It runs in parallel and its result will appear here: this is not a fault.",
  screeningExternalPending: "The external eligibility check opened a review at the partner bank. An analyst is clearing name matches there, and their decision will be notified to us. Onboarding is not blocked meanwhile.",
  riskFactorsTitle: "Risk factors",
  riskFactorsDecisive: "Decisive factors",
  riskFactorsOthers: "Other assessed factors",
  riskFactorsScore: "Score",
  riskFactorsCompleteness: "File completeness",
  riskFactorsHardOverride: "Override rule applied",
  riskFactorsUnavailable: "Risk factor details are unavailable for this file.",
  riskFactorNotApplicable: "Not assessed",
  riskFactorUnknownCode: "Unknown code",
  riskFactorNoValue: "No value provided",
  riskFactorsColEntity: "Entity",
  riskFactorsColValue: "Value",
  riskFactorsColLevel: "Level",
  riskFactorsColPoints: "Points",
  riskFactorsAssessedEntities: "entities assessed",

  // Screening step & OCR
  ocrExtractionTitle: "OCR extraction",
  ocrExtractionDescription:
    "Fields extracted by OCR can be reviewed and corrected before saving.",
  ocrStatusInProgress: "IN PROGRESS",
  ocrStatusFailed: "FAILED",
  ocrStatusReady: "READY",
  screeningInvalidIdTitle: "Invalid identity document",
  screeningInvalidIdDescription:
    "You cannot continue with an invalid identity document. Please upload a new valid document.",
  screeningInvalidIdInline:
    "You cannot continue while the identity document is invalid.",
  ocrApplyButton: "Validate and save",
  ocrApplyButtonLoading: "Processing...",

  // Result Screening
  SANCTIONS_PEP: "Sanctions PEP",
  ELIGIBILITE_EXTERNE: "External eligibility check",
  screeningStatus_clean_label: "CLEAN",
  screeningStatus_pending_label: "PENDING",
  screeningStatus_reject_label: "REJECTED",
  COMPLETUDE: "Completeness",
  OCR_QUALITE: "OCR quality",
  COHERENCE_IDENTITE: "Identity consistency",
  RISQUE_INITIAL: "Initial risk",

  productsAccounts: "Products & Accounts",
  productsAccountsDescription:
    "Select the type of client, product and services requested.",
  screeningContext: "Screening context",
  majorMinor: "Major/Minor",
  resident: "Resident",
  nonResident: "Non-resident",
  pepStatus: "PEP status",
  clientType: "Client type",
  product: "Product",
  productCategory: "Product category",
  additionalServices: "Additional services",
  classicCreditCard: "Classic credit card",
  classicCreditCardDescription: "Classic debit card",
  smsBanking: "SMS Banking",
  smsBankingDescription: "SMS alerts and operations",
  internetBanking: "Internet Banking",
  internetBankingDescription: "Web access to operations",
  checkbook: "Checkbook",
  checkbookDescription: "Nominative chequebook",

  // Screening status pills (labels)
  screeningStatus_ok_label: "OK",
  screeningStatus_avert_label: "WARN.",
  screeningStatus_alerte_label: "ALERT",
  screeningStatus_echec_label: "FAIL",
  screeningStatus_clear_label: "CLEAR",
  screeningStatus_faible_label: "LOW",
  screeningStatus_standard_label: "STANDARD",
  screeningStatus_high_label: "HIGH",
  screeningStatus_unknown_label: "UNKNOWN",
  screeningStatus_unknown_tooltip: "Unrecognized screening status.",

  // Screening status pills (tooltips by rule)
  screeningStatus_risqueInitial_ok: "No risk detected.",
  screeningStatus_risqueInitial_avert:
    "Moderate risk (invalid document, missing documents, etc.).",
  screeningStatus_risqueInitial_alerte: "High risk, manual review required.",

  screeningStatus_coherenceIdentite_ok: "Identity data are consistent.",
  screeningStatus_coherenceIdentite_avert:
    "Partial match (for example first names only).",
  screeningStatus_coherenceIdentite_echec:
    "Identity inconsistency or invalid identity document.",

  screeningStatus_ocrQualite_ok:
    "Quality verified, OCR data successfully extracted.",
  screeningStatus_ocrQualite_echec:
    "OCR data missing or unreadable, manual control required.",

  screeningStatus_completude_ok:
    "All required KYC documents have been provided.",

  screeningStatus_sanctionsPep_clear: "No sanctions / PEP match found.",
  screeningStatus_sanctionsPep_faible:
    "Low-relevance matches, to be monitored.",
  screeningStatus_sanctionsPep_standard:
    "Relevant matches, detailed review required.",
  screeningStatus_sanctionsPep_high:
    "High-relevance matches, high sanctions / PEP risk.",

  // Additional Documents Step (Onboarding)
  additionalDocumentsStepTitle: "Additional documents",
  requiredShort: "Required",
  optionalShort: "Optional",
  validatedShort: "Validated",
  pendingShort: "Pending",
  idDocumentName: "Identity document",
  proofOfResidenceUnder3Months: "Proof of address (≤ 3 months)",
  signedOpeningForm: "Signed account opening form",
  pepDeclaration: "PEP declaration",
  savingsObjectiveCertificate: "Savings objective certificate",

  // OCR sections
  ocrAddressContactTitle: "Address & contact",
  ocrIdentityTitle: "Client identity",
  ocrDocumentDetailsTitle: "Document details",
  ocrDocumentDetailsDescription:
    "Information extracted from the identity document. Review and correct if needed.",
  ocrFamilyTitle: "Family situation",
  ocrProfessionalTitle: "Professional situation",
  ocrAdditionalFieldsTitle: "Additional fields",
  placeholderPaysProfessionExample: "e.g. CI",

  // OCR placeholders/examples
  placeholderCityExample: "e.g. Paris",
  placeholderPostalCodeExample: "e.g. 75001",
  placeholderPlaceOfBirthExample: "e.g. Paris",
  placeholderDocumentNumberExample: "e.g. CI1234567890",
  placeholderCountryExample: "e.g. Côte d'Ivoire",
  placeholderNumberOfChildrenExample: "e.g. 2",
  placeholderProfessionExample: "e.g. Business owner",
  placeholderActivitySectorExample: "e.g. Agriculture",
  placeholderSalaryExample: "e.g. 450 000",

  // Core Banking Search
  coreBanking: "Core banking",
  searchCoreBanking: "Search for a client in core banking",
  searchCoreBankingDescription:
    "Enter an account number to query core banking. Results will appear in the list.",
  accountNumber: "Account number",
  searchCoreBankingTip:
    "Tip: you can close this dialog box, core banking results remain visible in the list.",

  // Empty State Messages
  noCustomersFound: "No customers found that match your search.",
  tryAdjustingFilters: "Try adjusting your filters to get more results.",
  startSearching: "Start by searching for or adjusting the filters above.",

  access_generated_successfully: "Access generated successfully",
  access_generated_successfully_description:
    "The access has been generated successfully. You can now log in.",
  access_generated_failed: "Failed to generate access",
  access_generated_failed_description: "An error occurred while generating.",
  access_generating: "Generating...",
  access_generating_description:
    "Access generation is in progress. Please wait.",
  regenerate_access: "Regenerate access",
  generate_access: "Generate access",
  revoke_access: "Revoke access",
  revoke_confirm_title: "Confirm access revocation",
  revoke_confirm_description:
    "This action immediately revokes the prospect's access. A reason is required.",
  revoke_sensitive_warning:
    "Sensitive action: access will be disabled immediately.",
  revoke_reason_label: "Reason",
  revoke_reason_placeholder: "Select a reason",
  revoke_reason_suspicion_fraud: "Fraud suspicion",
  revoke_reason_creation_error: "Creation error",
  revoke_reason_end_relationship: "End of prospect relationship",
  revoke_reason_customer_request: "Prospect request",
  revoke_reason_internal_control: "Internal control",
  revoke_reason_other: "Other",
  revoke_reason_custom_placeholder:
    "Specify the reason (minimum 10 characters)",
  revoke_reason_min_counter: "{{count}}/10 minimum characters",
  revoke_confirm_button: "Confirm revocation",
  revoke_confirming_button: "Revoking...",
  access_revoking: "Revoking access...",
  access_revoking_description:
    "Please wait while prospect credentials are being revoked.",
  access_revoked_successfully: "Access revoked",
  access_revoked_successfully_description:
    "Prospect access has been revoked successfully.",
  access_revoke_failed: "Failed to revoke access",
  access_revoke_failed_description: "Revocation failed. Please try again.",
  access_revoked_alert_title: "Access revoked",
  access_revoked_alert_description:
    "Access has been revoked. This prospect's access is now disabled.",

  missing: "Missing",
  uploaded: "Uploaded",
  verified: "Verified",
  required: "Required",
  optional: "Optional",
  clickToUpload: "Drop or click to add",
  notdocumentToUpload: "No document to upload",
  notdocumentToUploadDescription:
    "There are no documents to upload, you can submit the onboarding.",

  // KYC
  civilIdentity: "Civil Identity",
  actionRequired: "Action required",
  officialIdentifiers: "Official identifiers",
  notExpired: "Not expired",
  changeIdentity: "Replacement of identification document",
  contactDetails: "Contact details",
  mainMobileNumber: "Main phone number",
  secondaryMobileNumber: "Secondary phone number",
  taxationCompliance: "Taxation & Compliance",
  declarationPEP: "PEP declaration",
  CountryOfTaxation: "Country of tax residence",
  TaxIDNumber: "TIN /Tax ID number",
  pep: "PEP",
  residentStatus: "Resident status",
  residenceAddress: "Residence address",
  changeAddress: "Change address",
  reference: "Reference",
  balance: "Balance",
  money: "Currency",
  rib: "RIB",
  openAt: "Open at",
  downloadRIB: "Download RIB",
  ribDownloading: "Generating RIB...",
  ribDownloaded: "RIB downloaded",
  ribDownloadError: "Unable to download the RIB",
  miniStatement: "Mini-statement",
  viewMiniStatement: "View mini-statement",
  comingSoon: "Coming soon",
  debit: "Debit",
  movementLabel: "Label",
  movementSense: "Sense",
  movementAmount: "Amount",
  movementBalanceAfter: "Balance after operation",
  noMovements: "No movements on this account",
  miniStatementLoadError: "Unable to load the mini-statement",
  customerDocuments: "Customer documents",
  expiration: "Expiration",
  reusable: "Reusable",
  RelatedRequest: "Related requests",
  civility: "Civility",
  sectorActivity: "Sector of activity",
  comment: "Comment",
  contactForSavingCardCredit: "Contact for saving / card / credit",

  // Dashboard Page Not Ready
  dashboardPageNotReady: "Dashboard Under Development",
  dashboardPageNotReadyDescription:
    "This page is currently under development. It will be available soon with comprehensive features for managing your dashboard.",

  // Prospects & Client360 - Common
  all: "All",
  legalPerson: "Legal Person",
  moreCharacters: "more",
  start: "Start",
  end: "End",
  datePlaceholder: "dd/mm/yyyy",
  invalidAccountNumber: "This account number is invalid.",
  accountNumberExample: "Ex: 00XXXXXXXXXX",
  pageOf: "Page {0} of {1}",
  searchAndFilterProspects: "Search and filter prospects",
  identityRepository: "Identity Repository",
  importCsv: "Import CSV",
  newProspectRequest: "New prospect request",
  importing: "Importing...",
  importAction: "Save in the reference",

  // Prospects - Status & Types
  eligible: "Eligible",
  toComplete: "To complete",
  refused: "Refused",
  duplicatePending: "Duplicate pending",
  web: "Web",
  branch: "Branch",
  corporate: "Corporate",
  clearScreening: "Clear",
  possible: "Possible",
  matchedSanction: "Matched sanction",
  noneScreening: "None",

  // Core Banking Columns
  clientCode: "Client Code",
  lastNameColumn: "Last Name",
  genderColumn: "Gender",
  nationalityColumn: "Nationality",
  maritalStatusColumn: "Marital Status",
  postalCodeColumn: "Postal Code",
  phoneColumn: "Phone",
  lastUpdateAbbr: "Last Update",

  Voir: "Open",
  minor: "Minor",
  major: "Major",
  sinceAt: "Since at",
  viewer: "View",

  digits: "digits",
  maxPhoneCharactersMessage: "The phone number cannot exceed",
  minPhoneCharactersMessage: "The phone number must contain at least",

  assignments: "Summonses",
  attributeRole: "Assign role",
  noRolesFound: "No roles found",
  rolesPerPage: "Roles per page",

  // Administration
  featureComingSoon: "This feature will be available soon in production.",
  rolesAndRights: "Roles & Rights (RBAC)",
  rolesAndRightsDescription:
    "Administration of roles, users, and security settings",
  newUser: "New user",
  newUserDialogTitle: "Add a new user manually",
  newUserDialogDescription:
    "Create a user without AD synchronization. Enter the identity information.",
  editImportDescription: "Enter the information to manually import a user.",
  phone1: "Main phone",
  email1: "Main email",
  phone2: "Secondary phone",
  email2: "Secondary email",
  chooseOrEnterEmail: "Choose or enter an email",
  chooseOrEnterPhone: "Choose or enter a phone number",
  kycInformation: "KYC Information",

  // fiche-client360 specific
  identityDocument: "Identity document",
  phoneNumbers: "Phone numbers",
  primaryPhone: "Primary phone",
  secondaryPhone: "Secondary phone",
  fax: "Fax",
  primaryEmail: "Primary email",
  secondaryEmail: "Secondary email",
  emailAddresses: "Email addresses",
  noPhoneProvided: "No phone number provided",
  noEmailProvided: "No email address provided",
  notDetermined: "Not determined",
  recentScreeningReports: "Recent screening reports",
  accountsOverview: "Accounts (overview)",
  viewAllAccounts: "View all accounts",
  complianceTitle: "Compliance",
  nextReKYC: "Next Re-KYC",
  consentsSummary: "Consents (summary)",
  openConsentCenter: "Open Consent Center",
  noResult: "No results",
  loadingError: "Error loading data",
  title: "Title",
  dataset: "Dataset",
  statusRating: "Status/Rating",
  profileNotFound: "Profile not found",
  profileNotFoundDescription:
    "The profile you are looking for does not exist or has been deleted.",
  notVerified: "Not verified",
  otpVerificationRequired:
    "Modifying the phone or email requires OTP code verification.",
  verificationCodeSent: "Verification code sent to",
  didNotReceiveCode: "Didn't receive the code?",
  resendIn: "Resend in",
  resendCode: "Resend code",
  sendCode: "Send code",
  enterMinDigitsToReceiveCode:
    "Enter at least 10 digits to receive the verification code.",
  enterValidEmailToReceiveCode:
    "Enter a valid email address to receive the verification code.",
  verify: "Verify",

  // Client360 - access regeneration tooltip
  verify_contacts_before_regenerate_access:
    "Verify the client's email or phone number to enable access regeneration.",

  // Onboarding – validation errors
  onboarding_identityDocRequired:
    "An identity document (ID card or passport) is required",
  onboarding_addressProofRequired: "Proof of address is required",
  onboarding_idInvalidUploadNew:
    "The identity document is invalid. Please upload a new valid document.",
  onboarding_applyOcrAndFillRequired:
    "Please apply the OCR form and fill in all required fields.",
  onboarding_productsAccountsRequired:
    "Products and accounts information is required",
  onboarding_uploadRequiredDocsFirst:
    "Please upload the required documents first",

  // Onboarding – toasts & submit
  onboarding_resubmit: "Re-submit",
  onboarding_submittedSuccess: "Onboarding submitted successfully",
  onboarding_submitError: "An error occurred while submitting the form",
  onboarding_businessKeyMissing: "Business key is missing",
  onboarding_submitFailed: "Onboarding submission failed",
  onboarding_productsSaveSuccess: "Products saved successfully!",
  onboarding_productsSaveSuccessDesc:
    "Products have been saved and are being processed.",
  onboarding_productsSaveFailed: "Failed to save products",
  onboarding_productsSaveFailedDesc: "Products could not be saved.",
  onboarding_productsSaving: "Saving products...",
  onboarding_productsSavingDesc: "Please wait while we save the products.",
  onboarding_productsFetchFailed:
    "Failed to retrieve products & accounts information",
  onboarding_productsFetchError:
    "An error occurred while retrieving products & accounts information",
  onboarding_identitySavedSuccess: "Identity information saved successfully",
  onboarding_identitySaveFailed: "Failed to save identity information",
  onboarding_metadataSavedSuccess: "Metadata saved successfully",
  onboarding_metadataSaveFailed: "Failed to save metadata",
  onboarding_metadataSaveError: "An error occurred while saving metadata",

  // UserProfile
  roles: "Roles",
  lastConnection: "Last connection",
  profileCreatedAt: "Created at - Updated at",
  permission: "Permissions (preview)",
  recentActivities: "Recent activities",
  action: "Action",
  inactivate: "Inactivate",
  activate: "Activate",

  // Onboarding - Document Card
  removeFile: "Remove file",
  removeFileDescription:
    "Are you absolutely sure you want to remove this file? This action cannot be undone.",
  confirm: "Confirm",
  deleting: "Deleting...",

  // Roles Matrix
  preCheckSoD: "Pre-check SoD",
  roleName: "Role name",
  roleNamePlaceholder: "Ex: Management of the branch",
  purpose: "Purpose",
  purposePlaceholder: "Ex: Management of the branch",
  scope: "Scope",
  permissionSelected: "Permissions selected",
  selected: "selected",
  loadingPermissions: "Loading permissions…",
  domain: "Domain",
  description: "Description",
  grant: "Grant",
  preCheckSoDDescription:
    "Pre-check SoD automatically after modifying permissions.",
  noConflicts: "No conflict detected",
  conflict: "Conflict detected",
  restart: "Restart",
  noDetailsShown: "No details to show",
  usersList: "Users list",
  addNewUser: "Add new user",
  addNewUserDescription:
    "Search the user by their matricule to pre-fill their informations, then create their RBAC user.",
  createUser: "Create user",
  searchUser: "Search the user",
  confirmCreation: "Confirm the creation",
  userEmail: "User email",
  searching: "Searching...",
  userFound: "User found",
  selectedUser: "Selected user",
  rbacId: "RBAC ID (username)",
  usernameLettersNumbers: "Letters, numbers, points, underscores and dashes.",
  userWillBeCreatedInactive: "User will be created with status",
  withoutRoleAssigned: "and without role assigned.",
  activeSOD: "Active SOD",
  notAvailable: "Not available",
  na: "N/A",
  sodConflicts: "SOD conflicts detected",
  sodConflictsDescription:
    "This role has conflicts with separation of duties. A justification will be required.",
  highCriticality: "High criticality",
  highCriticalityDescription:
    "This assignment requires manager approval and a written justification.",
  attribute: "Assign",
  justification: "Justification",
  justificationRequired:
    "The justification must contain at least 10 characters.",
  selectedUsers: "selected user(s)",
  noPermissions: "No permissions",
  showMore: "Show more",
  showLess: "Show less",
  owner: "Owner",
  numberOfAssignments: "Number of assignments",
  userFile: "User file",
  userFileDescription: "User file (summary of roles and permissions)",
  street: "Street",
  bankInformation: "Bank information",
  agencyCode: "Agency code",
  employmentType: "Employment type",
  company: "Company",
  otherInformation: "Other informations",
  profilRating: "Profil rating",
  customerDetailsFromCoreBanking: "Customer details from Core Banking.",
  importStep: "Update informations",

  // Commercial Dashboard (P1)
  commercialDashboard: "Commercial Dashboard",
  volumeOnboardingInities: "Volume onboarding initiés",
  kpiProspectsCrees: "Prospects Created",
  kpiKycCompletion: "KYC Completion Rate",
  kpiAvgTimeToCollect: "Avg. Collection Time",
  kpiConversionRate: "Prospect→Client Conversion Rate",
  kpiCeMois: "This month",
  kpiRetry: "Retry",
  kpiDataUnavailable: "Data temporarily unavailable",
  kpiOutlierBadge: "⚠ {{count}} file(s) > 90d",
  kpiConversionTooltip:
    "Rate calculated on prospects created and converted this month",
  kpiConversionSubLabel: "{{converted}} of {{total}} converted",
  kpiTipOnboardingVolume: "Number of onboarding files opened over the period and not yet submitted for validation.",
  kpiTipKycCompletion: "Share of clients whose KYC file was genuinely processed: identity completed and compliance check performed. A client imported from the core banking system without that journey counts in the denominator but not the numerator.",
  kpiTipTimeToCollect: "Average number of days between opening a file and submitting it. Files still in progress are counted up to today.",
  kpiTipConversion: "Share of files opened over the period that became clients. Files refused on compliance grounds are excluded.",
  kpiTipBranchSla: "Average number of days between opening the file and activating the account, for clients activated over the period.",
  kpiTipDocRejection: "Share of checked files with at least one rejected document (poor scan quality or identity mismatch). Plain completeness warnings are not counted.",
  kpiTipRekycBacklog: "Periodic review files past their due date. Pending the KYC review module.",
  kpiTipCommercialVolume: "Number of client accounts activated over the period, across all advisors.",
  kpiTipTriage: "Number of compliance alerts awaiting qualification by an analyst.",
  kpiTipEddDelay: "Average processing time of an enhanced due diligence case, from opening to decision.",
  kpiTipFalsePositive: "Share of qualified alerts that turned out to be no real match. A high rate points to overly broad filtering.",
  kpiTipBacklogAge: "Average age, in days, of alerts still awaiting qualification.",
  kpiTipSodConformity: "Share of published roles complying with segregation of duties, with no incompatible combination of functions.",
  kpiTipFourEyesSla: "Average validation time by the second approver in the four-eyes circuit.",
  kpiTipHighRiskCoverage: "Share of high-risk files already qualified by compliance. The remainder still awaits a decision.",
  kpiTipSodDerogation: "Number of segregation-of-duties waivers approved over the period.",
  kpiTipTriggerLabel: "Learn more about this indicator",
  kpiConvertedSubLabel: "{{converted}} of {{total}} converted",
  kpiDays: "d",
  kpiHours: "h",
  kpiActiveEddCasesSubLabel: "{{count}} case(s) in progress",
  kpiTrendUp: "Trending up",
  kpiTrendDown: "Trending down",

  // Dashboards — menu section & persona titles / breadcrumbs
  dashboardsSection: "Dashboards",
  dashboardCommercial: "Commercial (P1)",
  dashboardAgence: "Branch (P2)",
  dashboardCompliance: "Compliance (P3)",
  dashboardConformite: "Conformité (P4)",
  dashboardCommercialSubtitle:
    "Commercial activity and onboarding quality at a glance",
  dashboardAgenceSubtitle:
    "Branch account-opening and commercial production monitoring",
  dashboardComplianceSubtitle:
    "AML/CFT alert triage productivity and control quality",
  dashboardConformiteSubtitle: "SoD conformity, EDD coverage and derogations",
  agence: "Branch",

  // KPI — unavailable tile
  kpiComingSoon: "Coming soon",
  kpiComingSoonDescription: "This indicator is not available yet.",

  // KPI — P1 conversion drill-down card
  kpiConversionDrillDownCta: "View prospects to convert",

  // KPI — P2 (Branch)
  kpiBranchSla: "Avg. account opening time",
  kpiBranchSlaSubLabel: "{{count}} accounts opened",
  kpiDocRejection: "Document rejection rate",
  kpiDocRejectionSubLabel: "{{rejected}}/{{total}} documents rejected",
  kpiCommercialVolume: "Commercial production volume",
  kpiCommercialVolumeSubLabel: "Accounts opened in the period",
  kpiRekycBacklog: "Re-KYC backlog",

  // KPI — P3 (Compliance)
  kpiTriageProductivity: "Triage productivity",
  kpiTriageSubLabel: "{{count}} alerts in progress",
  kpiEddDelay: "Avg. EDD handling time",
  kpiFalsePositiveRate: "False-positive rate",
  kpiFalsePositiveSubLabel: "{{clear}}/{{total}} evaluated",
  kpiBacklogAge: "Avg. backlog age",

  // KPI — P4 (Conformité)
  kpiSodConformity: "SoD conformity rate",
  kpiSodConformitySubLabel: "{{compliant}}/{{total}} compliant roles",
  kpiFourEyesSla: "4-eyes validation SLA",
  kpiHighRiskCoverage: "High-risk / PEP EDD coverage",
  kpiHighRiskCoverageSubLabel: "{{covered}}/{{total}} customers covered",
  kpiHighRiskUncoveredPill: "{{count}} customers without valid EDD",
  kpiSodDerogation: "SoD derogations volume",
  kpiSodDerogationSubLabel: "{{count}} derogations granted",
  userMatricule: "User ID",
  function: "Job function",
  departement: "Department",

  assigningRoleToUsers: "Assigning role to users...",
  roleAssignedSuccessfully: "Role assigned to users successfully",
  roleAssignedSuccessfullyDescription: "Roles have been assigned successfully.",
  revokeRole: "Revoke role",
  revokeRoleConfirmTitle: "Revoke role",
  revokeRoleConfirmDescription:
    "This action removes the role from the user and is irreversible. Please justify this revocation.",
  revokingRole: "Revoking role...",
  roleRevokedSuccessfully: "Role revoked successfully",
  roleRevokedSuccessfullyDescription:
    "The role has been removed from the user successfully.",

  civilStatusAndCapacity: "Civil status & legal capacity",
  changeCivilStatus: "Change civil status",
  addLegalRepresentative: "Add legal representative",
  civilStatusLabel: "Civil status",
  legalCapacity: "Legal capacity",
  legalReferent: "Legal referent",
  fatherFirstNames: "Father's first names",
  motherFirstNames: "Mother's first names",
  deathDate: "Date of death",
  socioProfessionalSituation: "Socio-professional situation",
  updateIncomeEmployer: "Update income and employer",
  professionCountry: "Country of profession",
  clientQuality: "Client quality",
  monthlyRemuneration: "Monthly remuneration",
  bceaoSocioProNote:
    "BCEAO rule: category is distinct from profession. This data feeds the risk profile and Re-KYC periodicity.",
  matrimonialAndFamily: "Matrimonial regime & family",
  changeFamilySituation: "Change family situation",
  matrimonialRegime: "Matrimonial regime",
  marriageContract: "Marriage contract",
  spouseLastName: "Spouse's last name",
  spouseFirstName: "Spouse's first names",
  belongingAndBanking: "Belonging & banking status",
  relationOtherInstitutions: "Relationship with other institutions",
  bankPersonnel: "Bank staff",

  patrimoineRealEstateAssets: "Real estate assets",
  patrimoineRealEstateAssetsHint: "Apartments, houses, land, …",
  patrimoineHowManyProperties: "How many properties?",
  patrimoineAssetsInsured: "Are the assets insured?",
  patrimoineEstimatedValue: "Estimated value",
  patrimoineOtherBankAccounts: "Other bank accounts",
  patrimoineOtherBankAccountsHint: "Current account, savings, …",
  patrimoineTotalApproximateValue: "Total approximate value",
  patrimoineValuableObjects: "Valuable objects",
  patrimoineValuableObjectsHint: "Jewellery, art, …",
  patrimoineEdit: "Edit",

  roleBlocked: "Role blocked",
  roleBlockedDescription: "This role is blocked and cannot be published.",

  commercial: "Commercial (P1)",
  conformite: "Conformity (P4)",
  thisMonth: "This month",
  previousMonth: "Previous month",

  // Risk Entity Referential (US-6.5a)
  riskEntityReferential: "Scoring Referential",
  riskEntityReferentialDescription: "Manage risk level codes by entity type.",
  riskEntityTabEntities: "Risk entities",
  riskEntityTabWeighting: "Weighting",
  riskEntityWeightingDescription:
    "Each field accepts 0–100%. The two values must add up to exactly 100%.",
  riskEntityWeightingSectionTitle:
    "Identity Referential and External check weighting",
  riskEntityWeightingSectionSubtitle:
    "Allocate how much each external source contributes to the client risk score. A 100% split keeps the model balanced and easy to interpret.",
  riskEntityWeightingCardTitle: "Enter percentages",
  riskEntityWeightingTotalLabel: "Total",
  riskEntityWeightingLseg: "Identity Referential",
  riskEntityWeightingVneurone: "External check",
  riskEntityWeightingPercentHint: "Percentage (%)",
  riskEntityWeightingSubmitLoading: "Updating…",
  riskEntityWeightingValidate: "Update",
  riskEntityWeightingSumMustBe100:
    "Identity Referential + External check must add up to exactly 100%.",
  riskEntityWeightingInvalidPercent: "Enter a valid number.",
  riskEntityWeightingPercentRange: "Percentage must be between 0 and 100.",
  riskEntityWeightingSubmittedSuccess: "Weighting saved.",
  riskEntityWeightingConfigLoading: "Loading current weighting…",
  riskEntityWeightingReason: "Reason for change",
  riskEntityWeightingReasonPlaceholder:
    "E.g. switch to CONSERVATIVE mode — SteerCo decision 2026-07-15",
  riskEntityWeightingReasonRequired: "Reason is required.",
  riskEntityWeightingReasonMinLength:
    "The reason must be at least 5 characters long.",
  riskEntityWeightingHistorySheetTitle:
    "History — Identity Referential / External check weighting",
  riskEntityWeightingHistorySheetSubtitle:
    "Each row is a saved change (weights, author, reason).",
  riskEntityWeightingHistoryLoading: "Fetching history…",
  riskEntityWeightingHistoryEmpty: "No history entries yet.",
  riskEntityWeightingHistoryColDate: "Date",
  riskEntityWeightingHistoryColAuthor: "User",
  riskEntityWeightingHistoryColBefore: "Before (Identity Ref. / External)",
  riskEntityWeightingHistoryColAfter: "After (Identity Ref. / External)",
  riskEntityWeightingHistoryColReason: "Reason",
  entityType_OBJET_COMPTE: "Account Object",
  entityType_SOURCE_REVENU: "Income Source",
  entityType_PAYS: "Country",
  entityType_PROFESSION: "Profession",
  entityType_ACTIVITE: "Activity",
  entityType_PRODUIT: "Product",
  entityType_CANAL: "Channel",
  entityType_ANNEE_CONSTITUTION: "Incorporation Year",
  riskLevel_RE: "RE — High Risk",
  riskLevel_RM: "RM — Moderate Risk",
  riskLevel_RF: "RF — Low Risk",
  riskEntityCode: "Code",
  riskEntityLibelle: "Label",
  riskEntityLevel: "Level",
  riskEntityActive: "Active",
  riskEntityLastModified: "Last modified",
  riskEntityAddCode: "Add a code",
  riskEntityEditLevel: "Edit level",
  riskEntityDeactivate: "Deactivate",
  riskEntityHistory: "History",
  riskEntityNewCode: "New code",
  riskEntityEditCode: "Edit code",
  riskEntityDeactivateTitle: "Deactivate this code?",
  riskEntityDeactivateDescription:
    "The code will be hidden from scoring but remain visible in the table.",
  riskEntityRollbackTitle: "Restore this version?",
  riskEntityRollbackDescription:
    "This action will apply the previous state and create an audit entry.",
  riskEntityRollbackConfirm: "Restore",
  riskEntityRestoreVersion: "Restore this version",
  riskEntityChangeReason: "Reason for change",
  riskEntityChangeReasonPlaceholder: "Enter the reason for this change…",
  riskEntityNoCodesFound: "No codes found",
  riskEntityFilterByLevel: "Filter by level",
  riskEntityAllLevels: "All levels",
  riskEntitySearchPlaceholder: "Search by code or label…",
  riskEntityStatusActive: "Active",
  riskEntityStatusInactive: "Inactive",
  riskEntityHistoryAction_ADD: "Addition",
  riskEntityHistoryAction_MODIFY: "Modification",
  riskEntityHistoryAction_DEACTIVATE: "Deactivation",
  riskEntityHistoryAction_ROLLBACK: "Rollback",
  riskEntityCreatedSuccess: "Code created successfully",
  riskEntityUpdatedSuccess: "Level updated successfully",
  riskEntityDeactivatedSuccess: "Code deactivated successfully",
  riskEntityRolledBackSuccess: "Version restored successfully",
  riskEntityOperationFailed: "Operation failed. Please try again.",
  riskEntityCodes: "code(s)",
  riskEntityModifyConfirmTitle: "Confirm modification",
  riskEntityNoHistory: "No history available for this entity type.",

  // Risk Entity Referential — CSV Import (US-6.5b)
  riskEntityImportCsv: "Import CSV",
  riskEntityImportModalTitle: "Import codes via CSV",
  riskEntityImportDropzone: "Drag & drop a .csv file here or click to select",
  riskEntityImportDropzoneHint:
    "Expected format: code,label,risk_level (UTF-8)",
  riskEntityImportSelectFile: "Select a file",
  riskEntityImportPreviewTitle: "Preview changes",
  riskEntityImportAdded: "Added",
  riskEntityImportModified: "Modified",
  riskEntityImportUnchanged: "Unchanged",
  riskEntityImportInvalid: "Invalid",
  riskEntityImportConfirmBtn: "Confirm import",
  riskEntityImportSuccess:
    "Import applied: {applied} modified, {added} added, {errors} errors",
  riskEntityImportShowUnchanged: "Show unchanged",
  riskEntityImportHideUnchanged: "Hide unchanged",
  riskEntityImportErrorReason: "Reason",
  riskEntityImportEmpty: "The file is empty or contains no valid rows.",
  riskEntityImportFileTypeError:
    "Unsupported format. Please select a .csv file.",
  riskEntityImportColumnCode: "Code",
  riskEntityImportColumnLabel: "Label",
  riskEntityImportColumnOldLevel: "Current level",
  riskEntityImportColumnNewLevel: "New level",
  riskEntityImportColumnStatus: "Status",
  riskEntityImportChooseAnother: "Choose another file",
  riskEntityImportConfirmCloseTitle: "Cancel import?",
  riskEntityImportConfirmCloseDescription:
    "The parsed file will be discarded. You will need to select it again.",

  // Risques Conformité — menu
  risquesConformite: "Compliance & Risk",
  fileDeRevueL1: "Review queue",
  validation4Yeux: "Reclassifications",

  // EDD 4-yeux module
  eddTitle: "Due diligence (EDD)",
  eddEmpty: "No EDD cases.",
  eddColBusinessKey: "Business ID",
  eddColCustomer: "Customer",
  eddColTrigger: "Trigger",
  eddColStatus: "Status",
  eddColAnalyst: "Analyst",
  eddColCreatedAt: "Created",
  eddFilterAll: "All",
  eddFilterAssignedToMe: "Assigned to me",
  eddStatus_OPEN: "Open",
  eddStatus_IN_PROGRESS: "In progress",
  eddStatus_PENDING_L1: "Pending L1",
  eddStatus_PENDING_L2: "Pending L2",
  eddStatus_APPROVED: "Approved",
  eddStatus_REJECTED: "Rejected",
  eddStatus_SUSPENDED: "Suspended",
  eddTrigger_PEP: "PEP",
  eddTrigger_PEP_SANCTIONED: "PEP + sanctioned country",
  eddTrigger_HIGH_RISK: "High risk",
  eddTrigger_KYB_HIGH_RISK: "High risk of the company (KYB)",
  eddTrigger_MANUAL: "Manual",
  eddTrigger_ESCALATION_L1: "L1 review escalation",
  eddTrigger_RE_KYC: "Re-KYC",
  eddTrigger_TRANSACTION_ALERT: "Transaction alert",
  eddTrigger_UNKNOWN: "Other",
  eddDocType_IDENTITY: "Identity document",
  eddDocType_SOURCE_OF_FUNDS: "Source of funds",
  eddDocType_BUSINESS_ACTIVITY: "Business activity",
  eddDocType_BENEFICIAL_OWNER: "Beneficial owner",
  eddDocType_OTHER: "Other",
  eddDocumentsTitle: "Supporting documents",
  eddNoDocuments: "No documents.",
  eddDownload: "Download",
  eddPreview: "Preview",
  eddUploadTitle: "Add a document",
  eddUploadType: "Document type",
  eddUploadFile: "File",
  eddUploadComment: "Comment (optional)",
  eddUploadSubmit: "Upload",
  eddHistoryTitle: "History",
  eddActionAddDocument: "Add a document",
  eddActionSubmitL1: "Submit for L1 review",
  eddActionSubmitL1Hint: "At least one 'Source of funds' document is required.",
  eddActionAssign: "Take ownership",
  eddActionSuspend: "Suspend",
  eddActionResume: "Resume",
  eddActionApproveL1: "Approve (L1 branch)",
  eddActionApproveL2: "Approve (L2 compliance)",
  eddActionApproveL2FourEyesHint:
    "Four-eyes control: the L2 approver must differ from the L1 approver.",
  eddActionReject: "Reject",
  eddRejectReason: "Rejection reason",
  eddSuspendReason: "Suspension reason",
  eddMfaTitle: "Security verification (MFA)",
  eddMfaSentTo: "A verification code was sent to",
  eddMfaTestMode: "Test environment: no mail was sent. Enter the test code:",
  eddMfaExpiresIn: "expires in",
  eddMfaSendError: "Could not send the verification code. Please retry.",
  eddMfaCodeLabel: "Verification code",
  eddMfaResend: "Resend a code",
  eddMfaValidate: "Verify and confirm",
  eddDecisionNotes: "Notes (optional)",
  eddApproveL2Title: "Approve (L2 compliance)",
  eddApproveL2RiskAssessment: "Risk re-assessment",
  eddApproveL2Conclusion: "Conclusion (optional)",
  eddRisk_MAINTAINED: "Maintained",
  eddRisk_UPGRADED: "Upgraded",
  eddRisk_DOWNGRADED: "Downgraded",

  // L1 Review page (US 6.3)
  l1ReviewTitle: "L1 review queue",
  l1ReviewBusinessKey: "Business Key",
  l1ReviewCustomerName: "Name",
  l1ReviewAssignedTo: "Assigned to",
  l1ReviewUnassigned: "Unassigned",
  l1ReviewRisk: "Risk",
  l1ReviewTabPending: "Pending",
  l1ReviewTabEscalated: "Escalated",
  l1ReviewTabAuthorized: "Authorized",
  l1ReviewTabRejected: "Rejected",
  l1ReviewTabSlaBreached: "SLA breached",
  l1ReviewDetailTitle: "L1 review case detail",
  l1ReviewDetailNotFound: "Case not found.",
  l1ReviewTriggerReason: "Trigger",
  l1ReviewTrackAScore: "Identity Reference score",
  l1ReviewTrackBScore: "External check score",
  l1ReviewSlaDeadline: "SLA Deadline",
  l1ReviewSlaExpired: "SLA Expired",
  l1ReviewAuthorize: "Authorize",
  l1ReviewSuspend: "Suspend",
  l1ReviewReject: "Reject",
  l1ReviewAssign: "Assign to me",
  l1ReviewHeldBy: "Already assigned; only its assignee can act on it",
  l1ReviewAssignHint: "Assign the case to yourself before authorizing it.",
  l1ReviewQualifyFirstHint:
    "Resolve every match first: the decision can only be made once you know whether this is the person.",
  l1ReviewEscalate: "Escalate",
  l1ReviewSuspensionReason: "Suspension reason",
  l1ReviewSuspensionReasonPlaceholder: "Describe the reason for suspension…",
  l1ReviewAuthorizeSuccess: "Case authorized successfully.",
  l1ReviewSuspendSuccess: "Case suspended successfully.",
  l1ReviewEscalateSuccess: "Case escalated to P4 validation.",
  l1ReviewActionFailed: "Action failed. Please try again.",
  l1ReviewEmpty: "No pending cases to review.",
  l1ReviewLoading: "Loading pending cases…",
  l1ReviewLoadingError: "Failed to load cases. Please retry.",

  // P4 Validation page (US 4.5)
  p4ValidationTitle: "Risk reclassifications (P4)",
  p4ValidationBusinessKey: "Customer ID",
  p4ValidationOldClass: "Current class",
  p4ValidationNewClass: "New class",
  p4ValidationScoreDelta: "Score Δ",
  p4ValidationTrigger: "Trigger",
  p4ValidationSlaDeadline: "SLA Deadline",
  p4ValidationSlaExpired: "SLA Expired",
  p4ValidationFlaggedDirectionRisques: "Flagged — Direction Risques",
  p4ValidationApprove: "Approve",
  p4ValidationReject: "Reject",
  p4ValidationJustification: "Justification",
  p4ValidationJustificationPlaceholder:
    "Provide a justification for rejection (min. 10 characters)…",
  p4ValidationNotes: "Notes (optional)",
  p4ValidationNotesPlaceholder: "Additional notes…",
  p4ValidationApproveSuccess: "Validation approved. New risk class applied.",
  p4ValidationRejectSuccess:
    "Validation rejected. Current risk class preserved.",
  p4ValidationActionFailed:
    "The action could not be completed. Please try again shortly.",
  p4ValidationForbidden:
    "You are not allowed to validate a risk reclassification. This decision is reserved for a Compliance Manager (P4).",
  p4ValidationSelfReviewForbidden:
    "Decision not allowed: under the four-eyes principle, the person who triggered the change cannot validate it. Another reviewer must handle it.",
  p4ValidationAlreadyDecided:
    "This reclassification has already been handled by another reviewer. The list will refresh.",
  p4ValidationEmpty: "No reclassification to validate right now.",
  p4ValidationEmptyApproved: "No approved reclassification to display.",
  p4ValidationEmptyRejected: "No rejected reclassification to display.",
  p4ValidationLoading: "Loading reclassifications…",
  p4ValidationLoadingError: "Failed to load reclassifications. Please retry.",
  p4ValidationPendingCount: "awaiting validation",
  // Status filter + business descriptions above the list
  p4StatusPending: "To validate",
  p4StatusApproved: "Approved",
  p4StatusRejected: "Rejected",
  p4StatusDescPending:
    "These customers' risk level has changed (e.g. Low → High). A second reviewer must confirm or refuse the change before it becomes final. The customer stays active meanwhile.",
  p4StatusDescApproved:
    "Confirmed risk-level changes: the new level has been applied to the customer. Read-only history.",
  p4StatusDescRejected:
    "Refused risk-level changes: the customer keeps their previous level. Flagged cases are escalated to the risk department for follow-up.",

  // Compliance triage — shared header, SLA countdown, queue summary, toolbar
  l1ReviewSubtitle: "Level-1 review of screening alerts, sorted by deadline.",
  p4ValidationSubtitle:
    "Second-line check of risk-level changes (Low ↔ High) on existing customers, sorted by deadline.",
  eddSubtitle: "Enhanced due-diligence cases in progress (four-eyes).",
  slaDueIn: "Due in",
  slaOverdueSince: "Overdue by",
  queueTotalPending: "Pending",
  queueDueSoon: "Due < 2 h",
  queueBreached: "SLA breached",
  queueFlaggedDR: "Flagged DR",
  eddQueueOpen: "Open",
  eddQueuePendingL1: "Pending L1",
  eddQueuePendingL2: "Pending L2",
  eddRowClickHint: "Select a case to view its details.",
  eddOpenCaseAria: "Open case",
  eddDetailBack: "Back to cases",
  eddDetailCaseInfoTitle: "Case information",
  eddDetailSubmittedAt: "Submitted on",
  eddDetailL1ApprovedBy: "L1 approved by",
  eddDetailL2ApprovedBy: "L2 approved by",
  eddDetailSlaDeadline: "SLA deadline",
  eddDetailNotFound: "Case not found.",
  eddCustomerDetailsTitle: "Prospect details",
  eddCustomerLoadError: "Unable to load the prospect details.",
  eddCustomerDocumentsTitle: "Customer documents",
  eddCustomerNoDocuments: "No document.",
  eddCustomerDocColType: "Type",
  eddCustomerDocColName: "Document",
  eddCustomerDocColExpiration: "Expiration",
  eddCustomerDocView: "View",
  complianceSearchBusinessKey: "Business key",
  complianceFilterTrigger: "Reason",
  complianceFlaggedOnly: "Flagged DR only",
  p4ValidationRiskChange: "Risk-class change",
  l1AuthorizeConfirmTitle: "Authorize this review?",
  l1AuthorizeConfirmBody:
    "The review will be authorized and removed from the queue. This action is final.",
  l1EscalateConfirmTitle: "Escalate this review?",
  l1EscalateConfirmBody:
    "The review will be escalated to P4 validation. This action is final.",

  // Tracks are named after what they mean to the bank, never after the vendor behind them.
  cvTrackA: "Identity Referential",
  cvTrackB: "External check",
  cvFinalDecision: "Final decision",
  cvWeights: "Weights",
  cvDecidedBy: "Decided by",
  cvScoringWeights: "Scoring weights",
  cvCanCreate: "Creation allowed",
  cvCannotCreate: "Creation blocked",
  cvVerdictHold: "Under review",
  cvVerdictUnknown: "Unknown status",
  cvHoldPending:
    "Customer recorded, no account opened until the review is cleared",
  cvBlockingReason: "Blocking reason",
  cvVNeuroneMode: "External check mode",
  cvComputedAt: "Computed at",
  cvVerdictClean: "Clean",
  cvVerdictWait: "Wait",
  cvVerdictFlagged: "Flagged",
  cvVerdictBlocked: "Blocked",
  cvVerdictManualReview: "Manual review",
  cvPendingOver48h: "Pending over 48h",
  cvScreeningDetails: "Screening details",
  cvLoadError: "Unable to load verdict.",

  additionalInformationKYC: "Additional KYC information",
  additionalInformationKYCDescription:
    "Update the client's additional information.",
  financialSituationSection: "Financial situation",
  pepStatusSection: "PEP status",
  effectiveBeneficiarySection: "Effective beneficiary",
  wealthSituation: "Wealth situation",
  sourceOfFunds: "Source of funds",
  bankRelationPurpose: "Purpose of the banking relationship",
  taxResidenceCountry: "Tax residence (country)",
  pepFunctionExercised: "PEP function exercised",
  effectiveBeneficiary: "Effective beneficiary",
  effectiveBeneficiaryIdentity: "Identity of the effective beneficiary",
  placeholderWealthSituation: "E.g. real estate, savings, investments",
  placeholderSourceOfFunds: "E.g. salary, inheritance, asset sale",
  placeholderBankRelationPurpose:
    "E.g. savings, day-to-day operations, international transfers",
  placeholderTaxResidenceCountry: "E.g. Côte d'Ivoire",
  placeholderPepFunction: "E.g. minister, MP, judge…",
  placeholderEffectiveBeneficiaryIdentity:
    "E.g. full name and capacity of the beneficiary",
  immatriculationsSectionTitle: "Registrations",
  taxIdentifiersSectionTitle: "Tax identifiers",
  addImmatriculation: "Add a registration",
  saveRegistrations: "Save",
  addTaxIdentifier: "Add a tax identifier",
  removeImmatriculation: "Remove",
  removeTaxIdentifier: "Remove",
  registryType: "Registry type",
  registryTypeRCCM: "RCCM",
  registryTypeOther: "Other",
  immatriculationNumber: "Registration number",
  immatriculationDate: "Registration date",
  immatriculationStatus: "Verification status",
  statusVerified: "Verified",
  statusNotVerified: "Not verified",
  statusInProgress: "In progress",
  statusToReverify: "To re-verify",
  screeningStatusPending: "Screening pending",
  screeningRelaunch: "Relaunch the screening",
  screeningRelaunchAll: "Relaunch the screening of the pending people",
  screeningRelaunchDone: "Screening done.",
  screeningRelaunchStillPending: "Screening still deferred: complete the nationality of the person, then relaunch.",
  screeningRelaunchFailed: "The provider did not answer, try again later.",
  screeningRelaunchAlreadyDone: "This person is already screened.",
  screeningRelaunchScreenedLabel: "screened",
  screeningRelaunchStillPendingLabel: "still pending",
  screeningRelaunchFailedLabel: "failed",
  screeningStatusNoMatch: "Screening: no match",
  screeningStatusToQualify: "Screening: to qualify",
  screeningStatusMatch: "Screening: confirmed match",
  screeningStatusFailed: "Screening: provider failure",
  registrationSyncedReadOnly:
    "Added to the case. Verification status is decided by compliance, backed by proof.",
  justificationAlternative: "Alternative justification",
  pendingComplianceValidation: "Pending compliance validation",
  taxIdentifierType: "Tax identifier type",
  taxIdentifierTypeIFU: "IFU",
  taxIdentifierTypeNIF: "NIF",
  taxIdentifierTypeNINEA: "NINEA",
  taxIdentifierTypeOther: "Other",
  taxIdentifierValue: "Value",
  immatriculationGateBlocked:
    "The dossier cannot be approved until a registration is verified.",
  registrationVerificationDecide: "Decide on the verification",
  registrationVerificationTitle: "Verification decision",
  registrationVerificationTargetStatus: "Target status",
  registrationVerificationSource: "Verification source",
  verificationSummarySource: "Source",
  verificationSummaryBy: "Verified by",
  verificationSummaryJustification: "Justification",
  verificationSummaryNoJustification: "No justification kept for this decision (made before it was recorded).",
  verificationSummaryProof: "View the proof",
  verificationSourceRccm: "Trade and personal property credit register (RCCM)",
  verificationSourceCepici: "One-stop formalities office (CEPICI)",
  verificationSourceTaxAuthority: "Tax authority (DGI)",
  verificationSourceCourtRegistry: "Commercial court registry",
  verificationSourceOfficialJournal: "Official journal or legal notice",
  verificationSourceOriginalDocument: "Original document shown by the customer",
  verificationSourceOther: "Other",
  verificationSourceOtherPlaceholder: "Specify the source",
  registrationVerificationSourceRequired: "Choose the verification source.",
  registrationVerificationJustification: "Justification",
  registrationVerificationProofFile: "Proof to upload",
  registrationVerificationSubmit: "Save decision",
  registrationVerificationCancel: "Cancel",
  registrationVerificationProofRequired:
    "A proof file is required for the Verified status.",
  registrationVerificationPendingSync:
    "Save the case first before deciding on its verification.",
  registrationVerificationError:
    "The decision could not be saved. Check the information and try again.",

  ocrChangeCriticalTitle: "Identity information is about to change",
  ocrChangeCriticalIntro:
    "You are about to change information that identifies the customer:",
  ocrChangeCriticalConsequence:
    "This restarts the customer's compliance checks and is recorded under your name. Make sure it matches the document presented.",
  ocrChangeCriticalAttestation:
    "I confirm I checked this information against the original identity document",
  ocrChangeReasonLabel: "Reason for the change",
  ocrChangeReasonPlaceholder:
    "e.g. OCR misreading corrected against the document presented",
  ocrChangeSensitiveTitle: "Information changed by the new reading",
  ocrChangeSensitiveIntro:
    "Reading the document again changes the following information:",
  ocrChangeNewCaptureTitle: "Information detected on the document",
  ocrChangeNewCaptureIntro:
    "Reading the document detected the following information, not yet recorded on this file. Check it is correct before continuing:",
  ocrChangeDetectedValue: "Detected value",
  ocrChangeAlsoChanged: "Also changed:",
  ocrChangeLegalAgeWarning:
    "This date moves the customer from minor to adult (or the other way round): the list of required documents will change.",
  ocrChangeIdPaperWarning:
    "If this document number is already registered on another customer, the change will be rejected.",
  ocrChangeBefore: "Before",
  ocrChangeAfter: "After",
  ocrChangeCancel: "Cancel",
  ocrChangeConfirm: "Confirm the change",
  ocrChangeFieldLastName: "Last name",
  ocrChangeFieldFirstName: "First name",
  ocrChangeFieldBirthDate: "Date of birth",
  ocrChangeFieldIdPaperNumber: "Document number",
  ocrChangeFieldNni: "National ID number",
  ocrChangeFieldNationality: "Nationality",
  ocrChangeFieldBirthPlace: "Place of birth",
  ocrChangeFieldGender: "Gender",
  ocrChangeFieldDeliveryDate: "Issue date",
  ocrChangeFieldValidityDate: "Expiry date",
  staffDirectoryTitle: "Staff directory",
  staffDirectoryBranch: "Assigned branch",
  staffDirectoryEmail: "Email sent to screening",
  staffDirectoryNoBranch:
    "No assigned branch in the staff directory. The files you open carry neither adviser nor branch and are not screened: have your assignment created before registering a new customer.",
  staffDirectoryAmbiguousBranch:
    "Several assigned branches in the staff directory, so none can be used. The files you open are not screened until a single one remains.",
  staffDirectoryBranchCount: "Assigned branches",
    accountOpeningRecapDecision: "Decision",
    accountOpeningRecapRepresentatives: "Representatives",
    accountOpeningRecapRiskLevel: "Risk level",
    decisionJustificationLabel: "Justification",
    decisionMakerNameLabel: "Deciding agent",
    decisionOutcomeLabel: "Outcome",
    decisionOutcomeRequestAdditionalInfo: "Request additional information",
    decisionTitle: "KYB decision",
    pmScreeningLaunchButton: "Launch screening",
    pmScreeningNoHitsMessage: "No hits found. Screening is clear.",
    pmScreeningQualificationPending: "Pending",
    pmScreeningQualifyFalsePositive: "False positive",
    pmScreeningQualifyTruePositive: "True positive",
    pmScreeningUnqualifiedHitsBlockMessage:
    "Every hit must be qualified before continuing.",
    riskFactorScreeningHit: "Confirmed screening hit",
    riskLevelEleve: "High",
    riskLevelFaible: "Low",
    riskLevelModere: "Medium",
  
  stepDecision: "Decision",

  platformSettings: "Platform settings",
  platformSettingsDescription:
    "Module activation and toggles reserved to the editor.",
  kybModuleToggleTitle: "KYB module (legal entity onboarding)",
  kybModuleToggleDescription:
    "Enables or disables legal entity onboarding (KYB) across the whole application: PM segment, KYB cases, associated screens.",
  kybModuleToggleEnabled: "Enabled",
  kybModuleToggleDisabled: "Disabled",
  kybModuleUnavailableTitle: "Module not active",
  kybModuleUnavailableMessage:
    "This module is not active. Please request its activation in your subscription.",
  identityPolicyToggleTitle: "Reason required on identity changes",
  identityPolicyToggleDescription:
    "On: any change to an identifying field (name, first name, date of birth, ID number, national ID, nationality) requires a reason, rejected with 400 otherwise. Off: the reason stays optional.",
  screeningPolicyPepTitle: "Block creation on PEP hit",
  screeningPolicyPepDescription:
    "On: a Track A PEP hit blocks customer creation until 4-eyes EDD is APPROVED.",
  screeningPolicyHighTitle: "Block creation on HIGH scoring",
  screeningPolicyHighDescription:
    "On: a Track A HIGH score blocks creation and opens an L1 review (soft gate).",
  screeningPolicyVneuroneModeLabel: "VNeurone mode",
  screeningPolicyProviderLabel: "Active AML provider",
  secretEncryptionTitle: "Secret encryption",
  secretEncryptionDescription:
    "Turns a plaintext value into the ENC(...) format expected by .properties files and Kubernetes secrets, for a key rotation.",
  secretEncryptionInputLabel: "Plaintext value",
  secretEncryptionInputPlaceholder: "Paste the value to encrypt",
  secretEncryptionButton: "Encrypt",
  secretEncryptionOutputLabel: "Encrypted value",
  secretEncryptionCopy: "Copy",
  secretEncryptionCopied: "Copied to clipboard",
  secretEncryptionError: "Encryption failed. Please try again.",
  customerPurgeTitle: "Customer purge",
  customerPurgeDescription:
    "Fully deletes a customer (database, Keycloak identity, MinIO objects) to replay a test with the same ID document and phone number. Irreversible.",
  customerPurgeBusinessKeyLabel: "Customer businessKey",
  customerPurgeBusinessKeyPlaceholder: "e.g. aaa0087",
  customerPurgeButton: "Purge",
  customerPurgeConfirmTitle: "Confirm the purge",
  customerPurgeConfirmDescription:
    "This action is irreversible: all of the customer's data will be deleted.",
  customerPurgePasswordLabel: "Your password",
  customerPurgePasswordPlaceholder: "Password",
  customerPurgeConfirmButton: "Confirm the purge",
  customerPurgeSuccess: "Customer purged.",
  customerPurgeError: "Purge failed. Check the businessKey and your password.",
  customerPurgeUnlockButton: "Unlock",
  customerPurgeLockedHint: "Enter your password to unlock this zone.",
  customerPurgeBusinessKeyInvalid: "Expected format: 3 letters + 4 digits, e.g. aaa0087.",

  agences: "Branches",
  agencesDescription: "Branch directory - read-only.",
  agenceCode: "Code",
  agenceName: "Name",
  agenceCity: "City",
  agenceAddress: "Address",
  agenceContact: "Contact",
  agenceCoordinates: "Coordinates",
  agenceHours: "Opening hours",
  agenceHoursOrdinary: "Weekdays",
  agenceHoursSaturday: "Saturday",
  agenceHoursSunday: "Sunday",
  agenceEmptyState: "No branches found.",
  agenceLoadError: "Could not load the branch directory.",
  subscriptionChannel: "Subscription channel",
  ent360Identity: "Company identity",
  ent360Representatives: "Legal representatives",
  ent360Beneficiaries: "Beneficial owners",
  ent360NoData: "No data",
  ent360Declarant: "Declarant",
  ent360Documents: "Case documents",
  ent360Completeness: "Completeness",
  kybTabOverview: "Overview",
  kybTabCompany: "Company",
  kybTabPeople: "People",
  kybTabCompliance: "Compliance",
  kybTabDocuments: "Documents",
  kybTabAccess: "Mandates and access",
  kybTabHistory: "History and evidence",
  kybGuideOverview: "Where the case stands: the journey steps, the client and account opening at the CBS, and the open accounts. Start here to know what to do next.",
  kybGuideCompany: "Identity, contact and financial data of the company, as sent to the CBS when the account is opened.",
  kybGuidePeople: "The legal representatives and beneficial owners of the case, with their screening result.",
  kybGuideCompliance: "Compliance work: instruction, screening matches to qualify, level 1 validation and final decision.",
  kybGuideDocuments: "The documents required for this legal form and country, and their status: expected, received, validated or expired.",
  kybGuideAccess: "Who can act for the company: mandates, online banking access and signature grids.",
  kybGuideHistory: "The record of everything that happened on the case and the exportable evidence pack for inspection.",
  kybEditStep: "Edit",
  kybEditLocked: "Editable before submission, or when a complement is requested from the client.",
  kybDocsRequired: "Required",
  kybDocsOptional: "Optional",
  kybScreeningPerson: "Screening",
  kybAccountsTitle: "Open accounts",
  kybScreenMatch: "Confirmed match",
  kybScreenToQualify: "To qualify",
  kybScreenNoMatch: "No match",
  kybScreenFailed: "Screening failed",
  kybScreenNotScreened: "Not screened",
  kybScreenPending: "Awaiting the registry",
  kybSummaryTitle: "Compliance summary",
  kybSummaryReassure: "Sanctions and PEP screening ran on the company and its people. No match needs a decision.",
  kybSummaryAttention: "Some points remain open on this case.",
  kybSummaryEntityScreening: "Company screening",
  kybSummaryPeopleScreening: "People screening",
  kybSummaryBeneficiaries: "Beneficial owners verified",
  kybSummaryStructure: "Readable ownership structure",
  kybSummaryDocuments: "Case documents complete",
  kybSummaryInstruction: "Instruction",
  kybSummaryL1: "Level 1 validation",
  kybSummaryDecision: "Decision",
  kybSummaryDone: "Done",
  kybSummaryTodo: "To do",
  kybDocsCompany: "Company documents",
  kybDocsPeople: "Documents of the individuals",
  kybPiecePreview: "Preview",
  kybPieceReplace: "Replace",
  kybPieceReopen: "Put back on hold",
  kybPieceReopened: "Document put back on hold: it can be deposited again.",
  kybPieceReopenFailed: "The document could not be put back on hold.",
  kybComplementDeposit: "Deposit the document",
  kybComplementDepositValidated: "This document is already validated: put it back on hold from the list of documents before depositing a new one.",
  kybDocsAwaitedNote: "document(s) requested from the customer pending (not counted in the completeness above):",
  kybDocsCompletenessRequired: "Completeness of the mandatory documents",
  kybDocsOptionalPending: "optional document(s) not validated, without effect on the completeness:",
  kybPieceDeposit: "Upload",
  kybPiecePreviewTitle: "Document preview",
  kybPiecePreviewLoading: "Loading the document…",
  kybPiecePreviewUnavailable: "Preview unavailable for this document: open the file in a new tab.",
  kybPieceOpenNewTab: "Open in a new tab",
  kybPieceValidated: "Document validated.",
  kybProofsTitle: "Verification proofs",
  kybProofsEmpty: "No proof uploaded: a verified registration carries one.",
  kybProofsDecidedBy: "Decided by",
  kybPieceDepositDone: "Document saved.",
  kybPieceDepositFailed: "The upload failed, try again.",
  kybMaMandates: "Mandates",
  kybMaAccess: "Online banking access",
  kybMaGrids: "Signature grids",
  kybMaManage: "Manage",
  kybMaEmpty: "None yet",
  kybMaMandatesHelp: "Who can commit the company, up to which ceiling.",
  kybMaAccessHelp: "Who signs in to online banking for the company.",
  kybMaGridsHelp: "How many signatures per operation type and amount.",
  kybCbsStepApproved: "Case approved",
  kybCbsStepSent: "Sent to the CBS",
  kybCbsStepCreated: "Client and account created",
  kybCbsOpenedToast: "The account was opened at the CBS: the client and its account number are created.",
  kybCbsAccountNumber: "Account number",
  kybEditLockedStatus: "The case is \"{status}\": it can be edited before submission, or when compliance asks the client for a complement. Case created by {author}.",
  kybEditLockedRight: "Reserved for agents allowed to create and correct company cases.",
  uboPhLastName: "e.g. KOUASSI",
  uboPhFirstName: "e.g. Awa",
  uboPhDenomination: "e.g. HOLDING AFRIQUE SA",
  uboPhRegistration: "e.g. CI-ABJ-2020-B-12345",
  uboPhPercentage: "e.g. 25",
  uboPhControlBasis: "e.g. power to appoint most directors",
  uboPhFallback: "e.g. no one holds more than 25% or controls the company",
  uboPhOwner: "Choose the holder",
  uboPhCountry: "Choose a country",
  uboPhLegalForm: "Choose a legal form",
  uboPhLegalFormFirst: "Choose the country first",
  uboPhNationality: "Choose a nationality",
  uboPhDirector: "Choose the director",
  documentFreeOtherPlaceholder: "e.g. Insurance certificate",
  documentChecklistProgress: "mandatory documents in order",
  kybGuardBeneficialOwnerNotVerified: "A beneficial owner is not verified: verify it in the \"Shareholding & UBO\" step before approving.",
  kybVerifyButton: "Verify",
  kybVerifyTitle: "Verify this person",
  kybVerifyHelp: "Check the person against a deed: she will be marked verified with your name and the date. While a beneficial owner is not verified, the case cannot be approved.",
  kybVerifySource: "Deed relied on",
  kybVerifySourcePlaceholder: "Choose or type the deed",
  kybVerifySourceStatutes: "Articles of association",
  kybVerifySourceRegister: "Shareholders' register",
  kybVerifySourceMinutes: "General meeting minutes",
  kybVerifySourceRccm: "RCCM extract",
  kybVerifyConfirm: "Confirm verification",
  kybVerifyDone: "Person verified.",
  kybVerified: "Verified",
  kybNotVerified: "Not verified",
  kybVerifiedBy: "by",
  kybDetailProvider: "Provider",
  kybDetailReference: "Reference",
  kybDetailCaseReference: "Provider case",
  kybDetailResult: "Result",
  kybDetailScreenedAt: "Screened on",
  kybDetailReport: "Screening report",
  kybDetailDownload: "Download",
  kybDetailNotScreened: "Not screened yet",
  kybDetailBy: "By",
  kybDetailOn: "On",
  kybDetailNotes: "Instruction notes",
  kybDetailHitConclusions: "Match conclusions",
  kybDetailAssignee: "Assigned analyst",
  kybDetailHistory: "See the full history",
  kybDetailOpenCase: "Wizard step to fix",
  kybDetailToggle: "Show details",
  kybDetailNone: "Nothing to detail",
  kybDetailVerifyHint: "To verify in the People tab.",
  kybDetailOpaque: "An opacity indicator recommends an enhanced review.",
  kybDetailTransparent: "No opacity indicator found.",
  kybSummaryEdd: "Enhanced due diligence (EDD)",
  kybSummaryDocumentsAwaited: "awaited from the customer:",
  kybNextAwaitingClientNamed: "Documents awaited from the customer (submit the dossier again once received):",
  kybNextAssign: "Appoint the instructor who takes over the dossier: they instruct, another officer validates afterwards.",
  kybNextGoAssign: "Appoint",
  kybNextResubmit: "The requested documents have arrived: submit the dossier again to resume the instruction, the documents are then checked.",
  kybNextResubmitButton: "Submit the dossier again",
  kybDocsControlAfterResubmit: "Received documents are checked once the dossier is submitted again: the instruction is suspended while it waits for the customer.",
  kybSummaryEddNotRequired: "Not required",
  kybSummaryEddRequired: "Required: high-risk country, confirmed match or opaque structure",
  kybSummaryEddRequiredBecause: "Required:",
  kybSummaryEddDecided: "Closed, risk",
  kybEddUpgraded: "raised",
  kybEddMaintained: "maintained",
  kybEddDowngraded: "lowered",
  kybRiskTitle: "Company risk",
  kybRiskHelp: "Computed on five determinants of the company; each line says why. A confirmed match, a sanctioned or high-risk country, or an opaque structure force the high level.",
  kybRiskScore: "Score",
  kybRiskWeight: "Weight",
  kybRiskLow: "Low risk",
  kybRiskStandard: "Standard risk",
  kybRiskHigh: "High risk",
  kybRiskLevelRF: "Low",
  kybRiskLevelRM: "Moderate",
  kybRiskLevelRE: "High",
  kybRiskOverrides: "High level forced by",
  kybRiskEddRequired: "EDD required before approval",
  kybRiskEddOpen: "Handle the EDD",
  kybRiskOpenCase: "Open the KYB case",
  kybRiskLoadError: "Unable to compute the company risk.",
  kybEddKybCardTitle: "Company KYB case",
  kybEddKybCardHelp: "Why the EDD is required, and where the company's people, documents and screenings are handled.",
  kybDetCompany: "Company",
  kybSummaryPeopleClear: "with no match",
  kybScreenPep: "PEP confirmed",
  kybScreenSanction: "Sanction confirmed",
  kybScreenMatchUnknown: "Confirmed match (nature not specified)",
  kybScreenHomonyms: "homonyms discarded by the provider",
  kybScreenRetained: "Profile retained by the provider",
  kybScreenWhy: "The provider compared the name, date of birth and nationality of the case; it retains this profile and discards the homonyms.",
  kybScreenNoProfile: "No detailed profile was kept for this screening.",
  kybScreenToggle: "See the retained profile",
  kybEddDocsInKyb: "The documents of the company and its people are read and completed in the KYB case: do not ask for them again here.",
  kybEddScreeningInKyb: "People screening",
  kybAccountRequested: "Requested account",
  kybAccountRequestedHelp: "The product chosen when the case was created. The account does not exist yet: it is opened at the CBS, with its number, when the case is approved.",
  kybAccountToOpen: "To be opened at approval",
  kybDetailReportPdf: "PDF report",
  kybDetailReportError: "Unable to produce the screening report.",
  kybVerifyProof: "Supporting document",
  kybVerifyProofHelp: "Attach the deed itself (PDF or image): verification without a document is not accepted.",
  kybRiskCfgTab: "Company risk",
  kybRiskCfgTitle: "Company risk rule",
  kybRiskCfgIntro: "A company's risk is the weighted average of five determinants scored from 1 to 3. Weights and thresholds are set here; values per country and sector are set in the entities tab. A confirmed match, a sanctioned country or an opaque structure always force the high level, whatever these settings.",
  kybRiskCfgReferentialLink: "Edit the values per country and sector",
  kybRiskCfgWeights: "Determinant weights",
  kybRiskCfgTotal: "Total",
  kybRiskCfgCountry: "Country of incorporation",
  kybRiskCfgCountryHelp: "Risk of the country where the company is registered.",
  kybRiskCfgSector: "Business sector",
  kybRiskCfgSectorHelp: "Risk of the declared sector; unknown counts as moderate.",
  kybRiskCfgStructure: "Structure complexity",
  kybRiskCfgStructureHelp: "Opacity of the ownership chain.",
  kybRiskCfgOwners: "Beneficial owners' country",
  kybRiskCfgOwnersHelp: "Most exposed country among the beneficial owners.",
  kybRiskCfgScreening: "Screening result",
  kybRiskCfgScreeningHelp: "PEP or sanction match, or clean screening.",
  kybRiskCfgThresholds: "Class thresholds",
  kybRiskCfgThresholdsHelp: "Score from 1 to 3. Below the first threshold: low; up to the second: standard; above: high.",
  kybRiskCfgLowMax: "Low up to",
  kybRiskCfgStandardMax: "Standard up to",
  kybRiskCfgThresholdsInvalid: "Thresholds must be between 1.00 and 3.00, the first strictly below the second.",
  kybRiskCfgReason: "Reason for the change",
  kybRiskCfgReasonPlaceholder: "E.g.: annual review by the compliance committee",
  kybRiskCfgReasonHelp: "At least 10 characters. Kept in the history; risks already frozen at a decision do not change.",
  kybRiskCfgSave: "Save",
  kybRiskCfgSaved: "Risk rule saved.",
  kybRiskCfgSaveError: "The risk rule could not be saved.",
  kybRiskCfgLoadError: "The risk rule could not be loaded.",
  kybRiskCfgRetry: "Retry",
  kybRiskCfgHistory: "Change history",
  kybRiskCfgNoHistory: "No change: the default rule applies.",
  kybRiskFrozenTitle: "Risk at the time of the decision",
  kybRiskFrozenChanged: "The current calculation differs from the one the decision was based on.",
  kybInstructionHeadOfficeTag: "Head office",
  kybInstructionReadyConditions: "Conditions to move to validation",
  kybInstructionReadyCondInstruction: "An instruction is recorded (a note, or a conclusion on a hit)",
  kybInstructionReadyCondPieces: "No mandatory document is missing",
  kybInstructionReadyBlocked: "Complete the conditions above to mark the case ready.",
  kybComplementTitle: "Pieces asked of the client",
  kybComplementReceived: "Received",
  kybComplementWaiting: "Waiting for deposit",
  kybComplementFree: "To be checked by the analyst",
  kybInstructionReadyCondComplement: "The pieces asked of the client have arrived",
  uboRequiredLegend: "Required field",
  uboHoldersTitle: "Holders",
  uboNoLegalDetails: "Country and registration to complete",
  uboHoldersDesc: "The people and companies that own or control the company, directly or through an intermediate company.",
  uboHoldersEmpty: "No holder yet.",
  uboHoldersEmptyHint: "Add an individual or an intermediate company to start.",
  uboAddPersonCta: "Add an individual",
  uboAddLegalCta: "Add an intermediate company",
  uboAddEdgeCta: "Add an ownership link",
  uboDialogAdd: "Add",
  uboDialogPersonTitle: "Add an individual",
  uboDialogPersonDesc: "A person who owns a share of the company or of an intermediate company, or controls it. You will then link her to what she owns.",
  uboDialogLegalTitle: "Add an intermediate company",
  uboDialogLegalDesc: "A company standing between the company and its holders: it owns a share of the company, and others own it in turn.",
  uboDialogEdgeTitle: "Add an ownership link",
  uboDialogEdgeDesc: "Say who owns what: a person or a company owns a share of the company, or of an intermediate company.",
  uboFormErrorsBanner: "Fix the fields marked in red.",
  uboFieldRequired: "This field is required",
  uboBirthDateFuture: "The birth date cannot be in the future",
  uboPercentHint: "Between 0 and 100, up to three decimals (e.g. 25 or 12.5)",
  uboPercentRange: "The percentage must be above 0 and not exceed 100",
  uboPercentFormat: "Enter a number with up to three decimals (e.g. 25 or 12.5)",
  uboPercentOverTotal: "The total would exceed 100%: remaining",
  uboEdgeSelfOwned: "A company cannot own itself",
  uboEdgeDuplicate: "This link already exists: remove it before creating it again",
  uboCapacityAllocated: "Already allocated",
  uboCapacityRemaining: "Left to allocate",
  uboEdgesDesc: "Who owns what, with each share. For one holding, the total capital (or voting rights) cannot exceed 100%.",
  uboEdgesNeedHolder: "Add a holder first: a link joins two parties.",
  uboAnalysisDesc: "Computed from the links above; run the computation again after a change.",
  uboSummaryHolders: "Holders",
  uboSummaryLinks: "Ownership links",
  uboSummaryOwners: "Beneficial owners",
  uboBornOn: "Born on",
  uboNoIdentityDetails: "Identity to complete (birth date, nationality)",
  kybClosureTitle: "Close the case",
  kybClosureHelp: "The case is rejected. Closing is final: nothing is left to review and the case cannot be reopened. The reason is kept in the history.",
  kybClosureReasonLabel: "Reason for closing",
  kybClosureReasonRequired: "The reason for closing is required.",
  kybClosureAction: "Close the case",
  kybClosureDone: "Case closed.",
  kybMaNoneLive: "None in force",
  kybMaAndMore: "and {count} more: see Manage",
  kybMandateFilterLive: "In force",
  kybMandateNonClientHelp: "this does not block the mandate: the contact comes from the person linked to the case",
  kybMandateSectionPower: "Authority",
  kybMandateSectionPeriod: "Period",
  kybMandateSectionTrail: "Trail",
  kybDelegationExplain: "Delegate: the representative entrusts part of their powers to another person of the case, for a short, bounded period, with a ceiling no higher than their own. The delegation has no effect until compliance validates it, and it ends with the mandate.",
  kybAccessTallyActive: "active",
  kybAccessTallyPending: "awaiting creation",
  kybAccessTallySuspended: "suspended",
  kybAccessUsersTitle: "Users and access",
  kybAccessWithoutHelp: "These mandates are in force but have no online banking account yet: create the access so the representative can sign in.",
  kybAccessShowSuspended: "Show the {count} suspended access",
  kybAccessHideSuspended: "Hide suspended access",
  kybAccessColUser: "User",
  kybAccessColActions: "Actions",
  kybCurrencyPlaceholder: "Choose a currency",
  kybSelectPlaceholder: "Choose from the list",
  kybAmountPlaceholder: "E.g. 5,000,000",
  kybGridMaxPlaceholder: "Empty = no limit",
  kybMandatePerimeterPlaceholder: "E.g. Main current account: transfers and withdrawals",
  kybRevokeCommentPlaceholder: "E.g. end of the representative's term, deed attached to the case",
  kybProfileOperationPlaceholder: "Choose an operation",
  kybProfileLimitPlaceholder: "Ceiling, e.g. 5,000,000",
  kybProfileAccountsPlaceholder: "One account number per line, e.g. 08688603234",
  kybProfileCountryPlaceholder: "Add a country",
  kybGridRangeBelow: "Less than {max}",
  kybGridRangeBetween: "From {min} to less than {max}",
  kybGridRangeFrom: "From {min}",
  kybGridColAmount: "Operation amount",
  kybGridColRequired: "Signatures required",
  kybGridSignatureOne: "signature",
  kybGridSignaturesMany: "signatures",
  kybGridShowHistory: "Show the history of archived grids ({count})",
  kybGridHideHistory: "Hide the history",
  kybAccessIntro: "A corporate access is a representative's right to sign in to online banking on behalf of the company. It stems from a mandate: one mandate, one access. The rights profile sets what the representative can do there (accounts, operations, ceilings, countries, currencies).",
  kybAccessStatActive: "Active",
  kybAccessStatActiveHelp: "The online banking account exists and is confirmed: the representative can sign in, within the limits of their profile.",
  kybAccessStatPending: "Being created",
  kybAccessStatPendingHelp: "The online banking account is being prepared: identifier created, activation e-mail sent. Until it is confirmed it grants no right. If it lasts, check the representative's e-mail and phone, then refresh.",
  kybAccessStatSuspended: "Suspended",
  kybAccessStatSuspendedHelp: "Access is cut: the mandate has ended (expired or revoked) or the periodic recertification was not done. It is restored with a mandate in force or a recertification.",
  kybAccessUserDeactivatedHelp: "Online banking account disabled: a reactivation validated by P4 is required.",
  kybGridAllAmounts: "All amounts",
  kybGridTiersTitle: "Signature tiers",
  kybGridTiersHelp: "Each tier starts where the previous one stops; the first starts at 0. Leave « up to » empty on the last one: it has no limit.",
  kybGridToValidate: "Proposed grid",
  kybGridReplaced: "Grid currently in force",
  kybGridActivateArchives: "It will be archived as soon as the proposed grid is validated.",
  kybGridActivateFirst: "No grid is in force for this operation and currency: the proposed grid will be the first.",
  kybRecertSettingLead: "Every active corporate access must be reconfirmed regularly. Here is the schedule: when the task opens, how often, and what happens if nobody decides.",
  kybRecertStepNoticeUnit: "days of notice",
  kybRecertStepNoticeText: "The recertification task opens this many days before the access falls due.",
  kybRecertStepPeriodUnit: "months between two recertifications",
  kybRecertStepPeriodText: "Each active access is to be reconfirmed at this frequency: the manager certifies it, or revokes it.",
  kybRecertStepGraceUnit: "days of grace",
  kybRecertStepGraceText: "After the due date, with no decision within this delay, the access is automatically suspended.",
  kybRecertEmptyPendingTitle: "Nothing to recertify for now",
  kybRecertEmptyTitle: "No decision in this view",
  kybRecertEmptyPendingText: "A task opens {notice} days before the {period}-month due date of each active access. It will appear here as soon as that happens.",
  kybAccessCreateBlockedDeactivated: "First reactivate the user (P4 validation), in the table below.",
  kybRetentionRuleYearsUnit: "years of retention",
  kybRetentionRuleYearsText: "Each KYB case is kept for 10 years: this is the legal requirement. The deadline is the date this period ends.",
  kybRetentionRuleManualTitle: "Never deleted automatically",
  kybRetentionRuleManualText: "At the deadline, the compliance lead decides: extend the retention, freeze the case (legal hold) or request its deletion.",
  kybRetentionRuleSignaturesUnit: "signatures to delete",
  kybRetentionRuleSignaturesText: "A deletion happens only with the agreement of two distinct people: the first requests it, the second authorizes it.",
  kybRetentionEmptyTitle: "No case reaches its deadline within {days} days",
  kybRetentionEmptyText: "Cases appear here when their retention deadline approaches or has passed. There is nothing to decide while the list is empty.",
  kybRetentionSeeFurther: "See the next {days} days",
  kybMandateFieldOperations: "Operations covered",
  kybOptional: "optional",
  kybPerimeterActionFailed: "The operation did not complete.",
  kybPerimeterActivate: "Activate",
  kybPerimeterActivateCountryEffect: "Your signature allows KYB cases to be opened for this country, with the legal forms already activated.",
  kybPerimeterActivateCountryTitle: "Activate this country",
  kybPerimeterActivateFormEffect: "Your signature allows KYB cases to be opened for this form in this country.",
  kybPerimeterActivateFormTitle: "Activate this legal form",
  kybPerimeterActivateRequirementEffect: "Your signature makes this document required in the new cases concerned.",
  kybPerimeterActivateRequirementTitle: "Activate this requirement",
  kybPerimeterCancel: "Cancel",
  kybPerimeterCasesAllowed: "KYB cases can be opened",
  kybPerimeterColActions: "Actions",
  kybPerimeterColBasis: "Standard applied (law, article)",
  kybPerimeterColForm: "Legal form",
  kybPerimeterColLegalBase: "Applicable text",
  kybPerimeterColObligation: "Nature",
  kybPerimeterColPiece: "Document",
  kybPerimeterColPublishedAt: "Published on",
  kybPerimeterColQuantity: "Copies",
  kybPerimeterColState: "State",
  kybPerimeterColUbo: "Beneficial owners",
  kybPerimeterColVersion: "Version",
  kybPerimeterCountries: "Countries",
  kybPerimeterCountryActivated: "Country activated",
  kybPerimeterCountryDeactivated: "Country deactivated",
  kybPerimeterCountryOpened: "Country opened as a draft",
  kybPerimeterCountryReferences: "Country references",
  kybPerimeterCountryRequired: "Choose the country to open.",
  kybPerimeterCountryState: "Country state",
  kybPerimeterDeactivate: "Deactivate",
  kybPerimeterDeactivateCountryEffect: "No more KYB cases can be opened for this country. Cases already opened keep their version and continue.",
  kybPerimeterDeactivateCountryTitle: "Deactivate this country",
  kybPerimeterDeactivateFormEffect: "New cases will no longer be able to choose this form. Cases already opened continue.",
  kybPerimeterDeactivateFormTitle: "Deactivate this legal form",
  kybPerimeterDeleteDraft: "Delete the draft",
  kybPerimeterDeleteDraftEffect: "The draft disappears with no effect on cases: it had not been activated.",
  kybPerimeterDeleteDraftTitle: "Delete this draft",
  kybPerimeterEdit: "Edit",
  kybPerimeterResignWarning:
    "This line is active. Saving it puts it back to draft: it stops applying to new cases until the compliance officer re-activates it with a new signature.",
  kybPerimeterFieldBasis: "Regulatory basis",
  kybPerimeterFieldCentif: "National financial intelligence unit",
  kybPerimeterFieldComment: "Comment",
  kybPerimeterFieldCountry: "Country",
  kybPerimeterFieldCountryPlaceholder: "Choose a country",
  kybPerimeterFieldForm: "Legal form",
  kybPerimeterFieldFormPlaceholder: "Choose a form",
  kybPerimeterFieldJustification: "Justification",
  kybPerimeterFieldLaw: "Data legislation",
  kybPerimeterFieldLegalBase: "Applicable text",
  kybPerimeterFieldObligation: "Nature",
  kybPerimeterFieldOrgans: "Management bodies",
  kybPerimeterFieldPiece: "Document",
  kybPerimeterFieldPiecePlaceholder: "Choose a document",
  kybPerimeterFieldQuantity: "Minimum copies",
  kybPerimeterFieldRegistry: "Business register",
  kybPerimeterFieldRepresentation: "Legal representation",
  kybPerimeterFieldScope: "Scope",
  kybPerimeterFieldTax: "Tax authority",
  kybPerimeterFieldThreshold: "Holding threshold",
  kybPerimeterFieldUbo: "Beneficial owners required",
  kybPerimeterFormActivated: "Form activated",
  kybPerimeterFormAdd: "Add a form",
  kybPerimeterFormAddTitle: "Add a legal form",
  kybPerimeterFormDeactivated: "Form deactivated",
  kybPerimeterFormEditTitle: "Edit the legal form",
  kybPerimeterFormInvalid: "Choose a form and, if beneficial owners are required, a threshold between 1 and 100.",
  kybPerimeterFormsEmpty: "No legal form is set up for this country yet.",
  kybPerimeterFormsSubtitle: "Only activated forms allow a case to be opened in this country.",
  kybPerimeterFormsTitle: "Accepted legal forms",
  kybPerimeterGuideIntro: "Everything is prepared as a draft. Nothing applies until the compliance officer has signed the activation.",
  kybPerimeterGuideStep1: "1. Open the country",
  kybPerimeterGuideStep1Text: "Choose the country and enter its regime: business register, tax authority, financial intelligence unit and legislation. The compliance officer then activates it.",
  kybPerimeterGuideStep2: "2. Accept the legal forms",
  kybPerimeterGuideStep2Text: "Only activated forms allow a case to be opened. For each, enter the applicable text, the bodies and the beneficial owner threshold. \"Activate drafts\" signs every form at once.",
  kybPerimeterGuideStep3: "3. Define the documents",
  kybPerimeterGuideStep3Text: "Country defaults apply to every form; a form-specific requirement replaces the default. An optional document is accepted without blocking the case. An activated requirement can be deactivated: it goes back to draft.",
  kybPerimeterGuideStep4: "4. Publish the version",
  kybPerimeterGuideStep4Text: "The simulation shows what publishing changes and what prevents it. The published version is the one new cases use.",
  kybPerimeterJourneyTitle: "Where this country stands",
  kybPerimeterJourneyNext: "Next step",
  kybPerimeterJourneyGo: "Open the tab",
  kybPerimeterJourneyDone: "Done",
  kybPerimeterJourneyTodo: "To do",
  kybPerimeterJourneyActiveLabel: "Active",
  kybPerimeterJourneyDraftLabel: "Draft",
  kybPerimeterJourneyDisabledLabel: "Deactivated",
  kybPerimeterJourneyCountryActive: "The country is active: company cases can be opened.",
  kybPerimeterJourneyCountryNotActive: "The country is not active: no case can be opened. The compliance officer activates it from the country regime tab.",
  kybPerimeterJourneyFormsNone: "No legal form is admitted.",
  kybPerimeterJourneyDefaultsMissing: "No default document is active: publication will be blocked.",
  kybPerimeterJourneyVersionDraft: "A draft version is ready: simulate it, then publish it.",
  kybPerimeterJourneyVersionPublished: "Published version: no.",
  kybPerimeterJourneyVersionNone: "No published version: create a draft, simulate it, then publish it.",
  kybPerimeterActivateDrafts: "Activate drafts",
  kybPerimeterTodoRegime: "The country is not open: no company dossier can be opened there. Open it from the country regime.",
  kybPerimeterTodoFormsNone: "No legal form admitted: activate the ones the bank accepts (SARL, SA, GIE...).",
  kybPerimeterTodoFormsDraft: "legal form(s) in draft. A draft is a proposal not yet in force: it applies to no dossier. Activate it to admit it.",
  kybPerimeterTodoPiecesDefault: "No active default document: a dossier would have no required document. Activate at least one default document.",
  kybPerimeterTodoPiecesDraft: "document(s) in draft. A draft is a proposal not yet in force: it applies to no dossier. Activate it to require it from new dossiers (in the next published version), or delete it if it no longer has a purpose.",
  kybPerimeterTodoVersionDraft: "A version draft is ready: simulate what it would change, then publish it under signature. New dossiers will get this version.",
  kybPerimeterTodoVersionNone: "No published version: create a version draft, simulate it then publish it. Without a published version, a new dossier has no rule.",
  kybPerimeterDraftsExplainTitle: "document(s) in draft in this country",
  kybPerimeterDraftsExplain: "A draft is a proposal not yet in force: it applies to no dossier. Once activated under your signature, it will be required from new dossiers as of the next published version. You can also delete it. The drafts of every view of the country are counted here, even those the table below does not show.",
  kybPerimeterDraftSee: "See",
  kybPerimeterDraftsDialogList: "Documents that will be activated:",
  kybPerimeterActivateFormsTitle: "Activate the draft legal forms",
  kybPerimeterActivateFormsEffect: "Your signature activates all the draft legal forms of this country at once, as you see them. They allow cases to be opened as soon as the country is active.",
  kybPerimeterActivateRequirementsTitle: "Activate the draft required documents",
  kybPerimeterActivateRequirementsEffect: "Your signature activates all the draft required documents of this country at once, as you see them. They apply to new cases at the next publication.",
  kybPerimeterDraftsActivated: "Drafts activated",
  kybPerimeterDeactivateRequirementTitle: "Deactivate this requirement",
  kybPerimeterDeactivateRequirementEffect: "Your signature removes this document from the matrix: it becomes a draft again that you can edit then reactivate. Ongoing cases and published versions do not change; the matrix changes at the next publication.",
  kybPerimeterRequirementDeactivated: "Requirement deactivated",
  kybPerimeterGuideTitle: "How to activate a country",
  kybPerimeterHintActive: "Signed by the compliance officer: this item applies.",
  kybPerimeterHintDisabled: "Withdrawn by the compliance officer: cases already opened keep their version.",
  kybPerimeterHintDraft: "Prepared but not yet signed: this item does not apply.",
  kybPerimeterHintSuspended: "Suspended because the country is no longer active in the bank reference; it cannot be reactivated by hand.",
  kybPerimeterJustificationRequired: "The justification is required.",
  kybPerimeterLoadError: "The KYB scope could not be loaded.",
  kybPerimeterMenu: "KYB scope",
  kybPerimeterNo: "No",
  kybPerimeterNoCountry: "No country is open to KYB yet.",
  kybPerimeterObligationOptional: "Optional",
  kybPerimeterObligationRequired: "Required",
  kybPerimeterOpenCountry: "Open a country",
  kybPerimeterOpenCountryTitle: "Open a country to KYB",
  kybPerimeterPublishEffect: "Your signature makes this version active for the country's new cases. The previous version is archived.",
  kybPerimeterPublishTitle: "Publish this version",
  kybPerimeterRequirementActivated: "Requirement activated",
  kybPerimeterRequirementAdd: "Add a document",
  kybPerimeterRequirementAddTitle: "Add a required document",
  kybPerimeterRequirementDeleted: "Draft deleted",
  kybPerimeterRequirementEditTitle: "Edit the requirement",
  kybPerimeterRequirementInvalid: "Choose a document and a number of copies of at least 1.",
  kybPerimeterRequirementsDefaultsSubtitle: "They apply to every legal form in the country, unless a form has its own requirement.",
  kybPerimeterRequirementsDefaultsTitle: "Documents required by default",
  kybPerimeterRequirementsEmpty: "No requirement in this scope.",
  kybPerimeterRequirementsFormSubtitle: "A requirement added here replaces the country default for this form only. Optional, the document is still accepted without blocking the case.",
  kybPerimeterRequirementsFormTitle: "Documents specific to this form",
  kybPerimeterRetry: "Retry",
  kybPerimeterSaveDraft: "Save as draft",
  kybPerimeterSaved: "Saved as draft",
  kybPerimeterScopeDefaults: "Country defaults (all forms)",
  kybPerimeterSearch: "Search a country",
  kybPerimeterSelectCountry: "Choose a country in the list to see its regime, legal forms, documents and versions.",
  kybPerimeterSignedBy: "Signed by",
  kybPerimeterSimulationAdded: "Added",
  kybPerimeterSimulationBlocking: "Publication is blocked:",
  kybPerimeterSimulationCurrent: "current version",
  kybPerimeterSimulationModified: "Modified",
  kybPerimeterSimulationRemoved: "Removed",
  kybPerimeterSimulationTitle: "Simulation of version",
  kybPerimeterVersionCompare: "See the changes",
  kybPerimeterVersionDiscard: "Abandon the draft",
  kybPerimeterDiscardTitle: "Abandon this version draft",
  kybPerimeterDiscardEffect: "The draft disappears: it was never published and no dossier uses it, nothing else changes. You can create a new one whenever you want.",
  kybPerimeterVersionDiscarded: "Version draft abandoned",
  kybPerimeterComparisonTitle: "Changes of the version",
  kybPerimeterComparisonSince: "compared with version",
  kybPerimeterComparisonNone: "No change of rules between these two versions.",
  kybPerimeterComparisonFirst: "First version: nothing to compare.",
  kybPerimeterSimulationUnchanged: "No change compared with the current version.",
  kybPerimeterStatusActive: "Active",
  kybPerimeterStatusDisabled: "Disabled",
  kybPerimeterStatusDraft: "Draft",
  kybPerimeterStatusSuspended: "Suspended",
  kybPerimeterSubtitle: "The countries where the bank opens business cases, the legal forms it accepts, the documents it requires and the versions of this reference.",
  kybPerimeterTabForms: "Legal forms",
  kybPerimeterTabPieces: "Required documents",
  kybPerimeterTabRegime: "Country regime",
  kybPerimeterTabVersions: "Versions",
  kybPerimeterTitle: "KYB scope",
  kybPerimeterVersionActive: "Published",
  kybPerimeterVersionArchived: "Archived",
  kybPerimeterVersionCreateDraft: "Create a draft",
  kybPerimeterVersionDraftCreated: "Version draft created",
  kybPerimeterVersionHintActive: "Version in force for new cases.",
  kybPerimeterVersionHintArchived: "Former version, kept for the cases that used it.",
  kybPerimeterVersionHintDraft: "Version in preparation: not yet published.",
  kybPerimeterVersionPublish: "Publish",
  kybPerimeterVersionPublished: "Version published",
  kybPerimeterVersionSimulate: "Simulate publication",
  kybPerimeterVersionsEmpty: "No version published for this country.",
  kybPerimeterVersionsSubtitle: "A draft is simulated and then published under signature. The published version is the one new cases use; cases in progress keep theirs.",
  kybPerimeterVersionsTitle: "Reference versions",
  kybPerimeterYes: "Yes",
  kybPerimeterSnapshotForm: "Form",
  kybPerimeterSnapshotPiece: "Document",
  kybPerimeterSnapshotDefaults: "country default",
  kybPerimeterSnapshotUbo: "beneficial owners from",
  kybPerimeterSnapshotCopies: "copy(ies)",
};

export default en;
